import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, QueryList, ViewChild, ViewChildren, ViewContainerRef, ChangeDetectorRef, AfterContentChecked, HostListener, OnDestroy, ComponentFactoryResolver, Type } from '@angular/core';

import { DxFormComponent, DxListComponent, DxPopoverComponent, DxRadioGroupComponent, DxToolbarComponent } from 'devextreme-angular';

import { DxValidationGroupComponent } from "devextreme-angular/ui/validation-group";
import CustomStore from 'devextreme/data/custom_store';


import notify from 'devextreme/ui/notify';


import { NgxSpinnerService } from 'ngx-spinner';

import { AnagraficaService } from '../../services/anagrafica.service';
import { ComponentService } from '../../services/component.service';
import { FormsTemplateService, ISearchExpr } from '../../services/forms-template.service';
import Validator from "devextreme/ui/validator";
import ValidationEngine from "devextreme/ui/validation_engine";
import { alert, confirm } from 'devextreme/ui/dialog';
import { ActivatedRoute } from '@angular/router';
import { NicaDynamicContentComponent } from '../nica-dynamic-content/nica-dynamic-content.component';
import { isNumber } from 'util';

import { GrigliaComponent } from '../griglia/griglia.component';

import { NicaAnagraficaComponent } from '../nica-anagrafica/nica-anagrafica.component';

import ArrayStore from 'devextreme/data/array_store';
import DataSource from 'devextreme/data/data_source';
import { DxiTabComponent } from 'devextreme-angular/ui/nested';
import { environment } from '../../../environments/environment';
import ODataStore from 'devextreme/data/odata/store';




@Component({
  selector: 'app-nica-form',
  /* templateUrl: './new-nica-form.component.html',  */
  templateUrl: './nica-form.component.html',
  styleUrls: ['./nica-form.component.css'],
  host: {
    '(document:click)': 'onClickOutsideSearchBox($event)'
  },
})

export class NicaFormComponent implements OnInit, OnDestroy {

  @ViewChild('dynamicInsert', { static: false, read: ViewContainerRef }) dynamicInsert: ViewContainerRef;
  @ViewChild('dynamicComponentItem', { static: false }) dynamicComponentItem: NicaDynamicContentComponent
  @ViewChild('formEdit', { static: false }) formEdit: DxFormComponent;
  @ViewChild('staticList', { static: false }) staticList: DxListComponent;
  @ViewChild('autocompletetPopOver', { static: false }) autocompletetPopOver: DxPopoverComponent;
  @ViewChild('toolbarBottomForm', { static: false }) toolbarBottomForm: DxToolbarComponent;

  @ViewChildren(GrigliaComponent) griglie;

  @ViewChildren('radioGroups', { read: true }) radioGroups: QueryList<DxRadioGroupComponent>;
  @ViewChild('anatoolbarTop', { static: false }) anatoolbarTop: DxToolbarComponent;

  @ViewChildren('dynamicGrid', { read: true }) arrNicaAnagrafica1: QueryList<NicaAnagraficaComponent>;
  @ViewChildren('dynamicComponentItem') arrNicaAnagrafica: QueryList<any>;

  @ViewChildren('formTabs', { read: true }) formTabs: QueryList<DxiTabComponent>;




  @Input() SubjectCall: string;   // Richiama il service per costrure la form
  @Input() ApiCall: string;      // Chiamata api per ottenere i dati
  @Input() filterKey: string;   // url filter delle api (ES.Id IDSoggetto) 
  @Input() nomeTabella: string;  // Nome tabella come da istruzioni Swagger 
  @Input() queryString: string;  // Query String (?nomecampo={{valore}})tabella come da istruzioni Swagger 
  @Input() itemData             // dati passati quando viene richiamato il form in EntryComponent
  @Input() dataJson: any[];   // Passa il json con i dati anziche richimare l'api
  @Input() type: any   // per visualizzare la form suddifica in tab è false di default tabbed || tabbedStep || simpleForm(per form semplice)
  @Input() nCol: any
  @Input() heightForm: number //altezza form
  @Input() widthForm: number //altezza form
  @Input() minColWidth: number;
  @Input() CustomButtonSetForm  // Bottoni Custom per eventi esterni 
  @Input() CustomButtonSetFormTop  // Bottoni Custom per eventi esterni 
  @Input() disableEditForm: boolean  // Abilita salvataggio del FORM da componente se FALSE di solalettura

  @Input() toolbarTop: boolean = false
  @Input() toolbarBottom: boolean = false
  @Input() isPopUp: boolean = false
  @Input() ngClass: string;
  @Input() remoteService: boolean = false
  @Input() scrollingEnabled: boolean = true;
  @Input() footerDescTitle: string = '';

  @Input() parent;

  @Output() emittendButtonPush: EventEmitter<any> = new EventEmitter<any>(); //Emit all'esterno
  @Output() submitFormStep: EventEmitter<any> = new EventEmitter<any>(); //Emit all'esterno
  @Output() emittendButtonPushCustom: EventEmitter<any> = new EventEmitter<any>(); //Emit l'evento del bottone custom al padre

  /**
   * 
   *  Campi già valorizzati dopo il caricamento del form, il caricamento è necessario per poter usufruire dell'
   *  evento 
   * 
  */
  public static formDataBackupObject: any;

  buttons: any[];
  buttonsTop: any[] = [];

  addButtonStepOptions: any[];

  formTabselectedIndex: number = 0

  showButtonTrash: boolean[] = [false] //bootne pulisci campo
  cols: any = []; // colonne griglia dynamic 

  showDynamicContent: boolean; // proprietà per mostrare e nascondere popup dynamico 
  formActionType: string = 'insert' //Azione del Form se edit o insert
  formData: any = []; // che lo spiego a fare.

  dataSet: any[] = []; // vedi doc DxForm
  dataSetCopy: any[] = []; // vedi doc DxForm
  allDataChanged: any[] = [];

  // Variabile che invio al componente nica-dynamic-content
  apiSource: any; // da inviare al componente dinamico
  componentType: any; // tipo di componente da mostrare nel popup default: grid e list, ma viene definito nel formTemplare service questo serve solo per passare dato al popup
  componentData: string = ''; // 
  titleDynamic: any; // titolo del popup 
  offsetY: any; // variabile per il posizionamento in verticale del popup
  offsetX: string;// variabile per il posizionamento in verticale orizzontale del popup
  height: string; // variabile altezza per popup 
  width: string; // variabile larghezza per popup 
  imageSources: any[] = [];

  itemOptions: any[] = []; //per costruire i campi speciali nella form dall'html

  //buttonOptionsSubmit: { text: string; type: string; useSubmitBehavior: boolean; };

  dataSourceLookUp: any[] = []; // DataSource del campo tipo lookup

  rowSelectLookUp: any[] = []

  dataSetDesc: any = []; // :campi speciali | <compare la descrizione se il campo da inviare via API per il salvaggio è di tipo ID>
  enableEditDynamicGrid: boolean;
  disabledDynamicElement: boolean[] = [];

  searchData: any = []; /** Di default è un array ma può essere un dataSource se necessario */
  searchDataShow: boolean = false;

  colCountByScreen = {

    sm: 1,
  };
  buttonToolbarState: boolean = true;
  validateFormGroupName: string;
  rowSelectedLookUp: any[] = [];
  lookUpValue: any[] = [];

  dataSedDynamicContent: any[] = []
  elementTarget: string;

  showDynamicPopOver: boolean;


  elementTargetAuocomplete: string;
  widthTargetAuocomplete: number;
  heightTargetAuocomplete: number;
  titleTargetAuocomplete: number;
  dataGroupItems: any[] = []
  timeInterval: any;
  store: any[] = [];
  costantValuesToDynamic: any;
  groupAutocomplete: boolean;
  comparisonTarget: any[] = [];
  compareValue: any;
  inputFormData: any[] = [];
  heightWrap: any;
  innerWidth: any;
  innerHeight: any;
  fullScreen: boolean = false;

  indexPositionList:
    {
      group: number,
      item: number
    } = { group: 0, item: 0 };

  tempDataFields: string[] = [];
  dataFields: any[] = [];
  loadingVisible = false;
  showForm: boolean = false

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.innerWidth = window.innerWidth;
  }

  constructor(private elementRef: ElementRef, private anagraficaService: AnagraficaService, private userComponentService: ComponentService, private loader: NgxSpinnerService, private formservice: FormsTemplateService, private activatedroute: ActivatedRoute, private changeDetector: ChangeDetectorRef, private _componentFactoryResolver: ComponentFactoryResolver,) {

    this.validationCallbackFunction = this.validationCallbackFunction.bind(this);
    ///this.startComponent = this.startComponent.bind(this)

    //Per il momento Fare cosi 
    //locale('en');
    this.innerWidth = window.innerWidth;
    this.innerHeight = window.innerHeight;
  }
  ngOnDestroy(): void {

    NicaFormComponent.formDataBackupObject = undefined;

  }
  screen(width) {
    return width < 1280 ? 'sm' : 'md';
  }
  logga(e) { };
  /* ngOnChanges(e) {
     //////////console.log(this.dataJson)
     this.dataSet = this.dataJson
 
   }*/

  ngOnChanges() {
    //Ricorda lo hai fatto per i formulari quando ricarichi la form 
    this.formData = this.formservice.getService(this.SubjectCall)


  }
  ngAfterContentChecked(): void {
    this.changeDetector.detectChanges();
  }
  ngAfterViewInit() {

    setTimeout(() => {

      //var nsAzienda =this.dataJson['nsAzienda']
      $('.disabled').attr('readonly', 'true');

      $('.nica-plaintext-readonly').attr('readonly', 'true');

      /* var dxstatedisabled = $('.dx-state-disabled').find('.dx-texteditor-input')
      

      dxstatedisabled.each(function () {

        //console.log($(this));

        $(this).attr('tabindex', -1);
      }); */

      $('.disabled-tab').attr('tabindex', -1)

      try {
        $("input[type='text']").each(function () {
          $(this).attr("autocomplete", "off");
        });
        $(".dx-texteditor-input").each(function () {
          $(this).attr("autocomplete", "off");
        });

        let tagArr = document.getElementsByTagName("input");
        for (let i = 0; i < tagArr.length; i++) {
          tagArr[i].autocomplete = 'off';
        }
      }
      catch (e) { }
    }, 300);
    console.log($('.anagrafica-wrap'))
    if ($('.anagrafica-wrap').length > 0) {
      const wrapAnaHeigth = $('.anagrafica-wrap').height();

      let hNicaNavTabs = 0;
      let hBottomtoolbar = 0;
      let hCaption = 0;
      hNicaNavTabs = $('.anagrafica-wrap .nica-nav-tabs').height();
      hBottomtoolbar = $('.anagrafica-wrap .bottomtoolbar ').height();
      hCaption = 41.33


      let h = wrapAnaHeigth - hNicaNavTabs - hBottomtoolbar - hCaption
      if (this.SubjectCall != 'GiacenzeRifiuti') {
        //this.heightForm = h
      }

    }





  }

  ngOnInit() {


    this.validateFormGroupName = this.SubjectCall;
    //Forzo la  variabile formActionType


    /****Se apro form in EntryComponent Dinamico */

    if (typeof this.itemData != 'undefined') {


      if (this.itemData) {

        this.SubjectCall = this.itemData[0].SubjectCall;
        this.ApiCall = this.itemData[0].ApiCall;
        this.filterKey = this.itemData[0].filterKey;
        this.queryString = this.itemData[0].queryString;
        this.dataJson = this.itemData[0].dataJson;
        this.nCol = this.itemData[0].nCol;
        this.disableEditForm = this.itemData[0].disableEditForm;
        this.toolbarBottom = this.itemData[0].toolbarBottom;
        this.toolbarTop = this.itemData[0].toolbarTop;
        this.type = this.itemData[0].type;
        this.heightForm = this.itemData[0].heightForm;
        this.widthForm = this.itemData[0].widthForm;
        this.ngClass = this.itemData[0].ngClass;
        this.CustomButtonSetForm = this.itemData[0].CustomButtonSetForm;
        this.inputFormData = this.itemData[0].inputFormData
        this.validateFormGroupName = this.itemData[0].SubjectCall;
      }

    }





    document.onclick = () => {
      this.indexPositionList = { group: 0, item: 0 };
    }

    this.onValueChangeSimple = this.onValueChangeSimple.bind(this);
    this.setAutoCompliteValue = this.setAutoCompliteValue.bind(this);
    this.displayExprAuocomplete = this.displayExprAuocomplete.bind(this);
    this.keyPressAction = this.keyPressAction.bind(this);
    this.onFocusIn = this.onFocusIn.bind(this);


    /**********************************************/
    this.loader.show();

    if (typeof this.queryString != 'undefined' && this.queryString != '') {
      this.loadingVisible = true;
      this.formActionType = 'edit'

      this.getData('', '', this.queryString);


      return

    } else {
      //let dataJson =this.dataJson
      if (this.dataJson != undefined && Object.keys(this.dataJson).length > 0) {

        if (this.formActionType != 'edit') {
          this.SelectionRow(this.dataJson);

        }

      } else {
        this.renderTemplateForm();
      }
    }








  }

  renderTemplateForm() {

    if (this.remoteService) {
      this.getServiceFromApi(this.SubjectCall);

    } else {

      this.formData = this.formservice.getService(this.SubjectCall);


    }

    if (this.formData && !this.remoteService) {

      //Se in input è definito filterKey (id Tabella correlata esempio idSoggetto per la  teabella sede)  
      if (typeof this.filterKey != "undefined" && this.filterKey != '') {

        //this.dataSet = this.filterKey

      }

      this.loader.hide();
      ////console.log('group',this.formData.filter(r=>r.itemType=='group'))
      let formData = []


      formData = this.formData.filter(r => r.itemType == 'group');
      let newData: any[] = [];
      formData.forEach(gruppo => {
        let colCount = parseInt(gruppo.colCount);
        let contatore = 0;
        let rigaNumero = 1;
        gruppo.rowGroup = [];
        gruppo.data.forEach(dataR => {

          if (typeof dataR.labelVisible == 'undefined') {
            dataR.labelVisible = true
          }

          if (!dataR.colSpan) {
            dataR.colSpan = 1;
          }

          if (parseInt(dataR.colSpan) == colCount) {
            newData.push(dataR);
            contatore = colCount
          }

          if (contatore < colCount) {
            newData.push(dataR)
            contatore++
          }



          if (contatore == colCount) {
            gruppo.rowGroup[rigaNumero] = newData;
            newData = [];
            contatore = 0;
            rigaNumero++
          }
          if (this.innerWidth <= 1540) {
            //dataR.width = null ;

          }

        })



      })

      //console.log(formData)

      this.itemOptions = this.getDynamicOptions(formData);

    } else {



      //this.loader.hide();
      //alert("E' stato rilavato un problema  nel chiamare il service: " + this.SubjectCall, 'Attenzione')

    }

    if (typeof this.nCol == 'undefined') {
      this.nCol = 1;

    }

    this.renderToolBar();


    this.loader.hide();

    setTimeout(() => {
      if (this.formData.length > 0) {
        this.showForm = true;
      }
    }, 300);


  }


  getData(filterKey = '', filter = '', queryString = '') {

    this.anagraficaService.getElenco(this.ApiCall, filterKey, filter, queryString).then(subject => {

      if (subject['codeMessage'] == -1) {
        this.loadingVisible = false;

        notify({
          message: subject['descrMessage'],
          //message: 'Anagrafica salvata',
          height: 45,
          width: 250,
          position: 'center center'
        }, 'error', 3000);

        return;
      }

      if (subject['items']) {
        subject = subject['items'];
      } else {
        subject = subject;

      }
      let event = {
        name: 'formDataInit',
        formData: subject,
        masterComponet: (this.formEdit) ? this.formEdit.instance : undefined
      }
      this.emittendButtonPush.emit(event)
      this.SelectionRow(subject);

    });
  }

  formContentReady(e) {

    let dataToSend = {
      formData: this.dataSet,
      masterComponent: e.component,
      name: 'formContentReady',
      event: e
    }
    this.emittendButtonPush.emit(dataToSend);

    setTimeout(
      () => {

        /*  e.name = 'formContentInitializzed';
         this.emittendButtonPush.emit(e); */


        if (document.getElementsByClassName('dx-datebox-calendar'))
          for (let i = 0; i < document.getElementsByClassName('dx-datebox-calendar').length; i++) {

            if (!document.getElementsByClassName('dx-datebox-calendar').item(i))
              continue;

            (document.getElementsByClassName('dx-datebox-calendar').item(i).children.item(0).children.item(1).children.item(0).children.item(0) as HTMLInputElement).onclick = () => {

              (document.getElementsByClassName('dx-datebox-calendar').item(i).children.item(0).children.item(1).children.item(0).children.item(0) as HTMLInputElement).select();
              (document.getElementsByClassName('dx-datebox-calendar').item(i).children.item(0).children.item(1).children.item(0).children.item(0) as HTMLInputElement).focus();

            }

          }
      }, 1000
    );


    if (this.formData && (this.type == 'tabbedStep')) {
      this.formData.forEach(optionsData => {

        if (optionsData.caption == undefined || optionsData.caption == '') {
          return
        }
        let validationDataName = optionsData.caption.replace(/\s/g, '')

        optionsData.data.forEach(dataElement => {

          let valElement = this.formEdit.instance.getEditor(dataElement.dataField);
          let valInstance
          if (typeof valElement != 'undefined')
            valInstance = Validator.getInstance(valElement.element()) as Validator;
          if (typeof valInstance != 'undefined')

            valInstance.option("validationGroup", validationDataName);
        })

      })
    }


    ////console.log('formContentReady',e);

  }

  formInitializzed(ev) {
    ev.formData = this.dataSet
    ev.name = 'formContentInitializzed';
    this.emittendButtonPush.emit(ev);
  }

  renderToolBar() {


    this.buttons = [

      {
        location: "after",

        widget: "dxButton",
        locateInMenu: "never",
        useSubmitBehavior: false,
        options:
        {
          stylingMode: "text",
          text: 'Salva',
          icon: "glyphicon icon-salva-form",
          visible: this.disableEditForm ? false : true,
          onClick: ($event) => {

            let form = this.formEdit.instance;
            let dataEditForm = form.option("formData");

            $event.name = 'beforSave';
            $event.formData = dataEditForm;
            $event.masterComponent = form;

            this.emittendButtonPush.emit($event)


            let validation = ValidationEngine.validateGroup(this.SubjectCall); //this.formEdit.instance.validate();
            if (validation.isValid) {

              if (typeof $event.cancella != 'undefined') {

                if ($event.cancella) {
                  return
                }

              }

              if (typeof this.parent != 'undefined') {
                if (this.parent.callabckFunction instanceof Function) {
                  this.parent.callabckFunction($event).then(res => {
                    // funzione dovrebbere ritornare un json {result:boolean,message:string}
                    if (res.result == false) {
                      if (res.message)
                        alert(res.message, 'Salvataggio Dati')
                      return false;
                    } else {
                      if (res.message)
                        this.notifica(res.message, 'top', 'right')
                      this.onFormSubmit($event)
                    }
                  })
                }
              } else {
                this.onFormSubmit($event)

              }


            }
          }
        }


      },
      {
        location: "after",

        widget: "dxButton",
        locateInMenu: "never",
        useSubmitBehavior: true,

        options:
        {
          stylingMode: "text",
          text: 'Ritorna',
          icon: "glyphicon icon-annulla-form",

          visible: this.disableEditForm ? false : true,
          onClick: ($event) => {
            ////console.log('allDataChanged', this.allDataChanged)
            if (Object.keys(this.allDataChanged).length > 0) {
              confirm("Desideri salvare le modifiche? ", "Attenzione!").then(val => {
                if (val) {
                  this.onFormSubmit($event)

                  $event.name = 'return'
                  this.emittendButtonPush.emit($event)


                } else {
                  $event.name = 'return';
                  let form = this.formEdit.instance;
                  $event.data = form.option("formData");
                  this.emittendButtonPush.emit($event)
                }

              })
              //this.onFormSubmit($event)
            } else {
              //////////console.log(this.allDataChanged)
              $event.name = 'return'
              let form = this.formEdit.instance;
              $event.data = form.option("formData");
              this.emittendButtonPush.emit($event)
            }

          },
          onContentReady: ($event) => {
            $event.name = 'returnButton';
            this.emittendButtonPush.emit($event)
          }

        }


      },


    ]

    if (this.CustomButtonSetForm) {
      const buttonsToAdd = this.CustomButtonSetForm;
      buttonsToAdd.forEach(button => {
        this.buttons.push({

          location: button.location,
          widget: button.widget,
          locateInMenu: button.locateInMenu,

          options:
          {
            stylingMode: button.stylingMode,
            text: button.text,
            icon: button.icon,
            hint: button.hint,
            visible: true,
            disabled: button.disabled,
            onClick: (event) => {
              let dataEditForm = this.formEdit.instance.option("formData");
              let data = {
                name: button.event,
                eventName: 'buttonCustomClick',
                data: dataEditForm,
                masterComponent: this,
                component: this.formEdit.instance,

              }
              // this.emittendButtonPush.emit(data)
              this.emittendButtonPush.emit(button.event)
              this.emittendButtonPushCustom.emit(data)
            },
          }

        })
      })

    }

    if (this.CustomButtonSetFormTop) {
      const buttonsToAddT = this.CustomButtonSetFormTop;
      buttonsToAddT.forEach(button => {
        this.buttonsTop.push({

          location: button.location,
          widget: button.widget,
          locateInMenu: button.locateInMenu,

          options:
          {
            stylingMode: button.stylingMode,
            text: button.text,
            icon: button.icon,
            hint: button.hint,
            visible: button.visible,
            disabled: button.disabled,
            onClick: ($event) => {
              let event = {
                buttonEvent: $event,
                event: button.event,
                accesskey: button.accessKey,
                button: button,
                data: this.formEdit.formData,
                name: button.name
              }
              this.emittendButtonPush.emit(event)

            },
          }

        })
      })

    }

    this.addButtonStepOptions = [
      {
        location: "before",

        widget: "dxButton",
        locateInMenu: "never",
        useSubmitBehavior: false,

        options:
        {
          /* disabled: this.buttonToolbarState,*/
          text: 'Indietro',
          stylingMode: "text",

          icon: "glyphicon fas fa-angle-left",
          onClick: ($event) => {
            let tabs = this.formEdit.items[0]['tabs'];

            let currentIndex = this.formTabselectedIndex;

            let dataEditForm = this.formEdit.instance.option("formData");
            dataEditForm.action = 'Indietro';
            let validationDataName = tabs[currentIndex].title.replace(/\s/g, '')
            let validation





            validation = ValidationEngine.validateGroup(validationDataName);

            if (validation.isValid) {


              dataEditForm.step = currentIndex;
              dataEditForm.isValid = validation.isValid;



              if (currentIndex == tabs.length) {
                return
              }
              this.buttonToolbarState = false

              this.clickStep('Indietro')

            } else {

              dataEditForm.step = currentIndex;
              dataEditForm.isValid = validation.isValid


              return
            }

            this.submitFormStep.emit(dataEditForm);






          }
        }
      },
      {

        location: "after",

        widget: "dxButton",
        locateInMenu: "never",
        useSubmitBehavior: false,
        options:
        {
          text: 'Avanti',

          stylingMode: "text",

          icon: "glyphicon fas fa-angle-right",
          onClick: ($event) => {


            let tabs = this.formEdit.items[0]['tabs'];
            let currentIndex = this.formTabselectedIndex;

            let validationDataName = tabs[currentIndex].title.replace(/\s/g, '')
            let validation
            let dataEditForm = this.formEdit.instance.option("formData");
            dataEditForm.action = 'Avanti';

            validation = ValidationEngine.validateGroup(validationDataName);



            if (validation.isValid) {

              dataEditForm.step = currentIndex;
              dataEditForm.isValid = validation.isValid;

              if (currentIndex == tabs.length) {
                return
              }

              this.buttonToolbarState = false
              //this.clickStep('Avanti');

            } else {

              dataEditForm.action = 'Avanti';
              dataEditForm.step = currentIndex;
              dataEditForm.isValid = validation.isValid



            }
            this.submitFormStep.emit(dataEditForm);

            return

          }
        }


      }


    ]
  }
  async getServiceFromApi(subJectCall) {

    await this.anagraficaService.getValue('ModelloDiStampa', subJectCall, '').then(response => {
      this.formData = JSON.parse(response['json'])
    })

    if (this.formData) {
      let formData = []

      formData = this.formData.filter(r => r.itemType == 'group');



      this.itemOptions = this.getDynamicOptions(formData);
    }
    this.loader.hide();
  }

  getDynamicOptions(optionsData: any) {
    let validationDataName: string
    const options = [];
    for (let i = 0; i < optionsData.length; i++) {
      if (optionsData[i].grupped) {

      }
      if (this.innerWidth <= 1290) {
        optionsData[i].width = 900;
        //this.scrollingEnabled=false
      }
      if (optionsData[i].data)
        optionsData[i].data.forEach((data, key) => {
          this.dataFields[data.dataField] = data
          if (data.validation) {

            data.validation.forEach(validate => {
              if (validate.type == 'compare') {

                this.comparisonTarget[data.dataField] = validate.comparisonTarget;

              }

            })
          }


          /* if (data.width) {
            let width = data.width;
            let calcW
            if (this.innerWidth <= 1290) {
             
              if (data.width.includes('px')) {
                width = data.width.replace('px', '');
                calcW = 100 * width / this.innerWidth;

              }
              if (data.width.includes('vw')) {
                width = data.width.replace('vw', '');
                let calcWConvert = this.innerWidth * width / 100;
                calcW = 100 * calcWConvert / this.innerWidth;
              }

              data.width = calcW + 'vw';
              //this.scrollingEnabled=false
            }else{
               if (data.width.includes('px')) {
                width = data.width.replace('px', '');
                calcW = 100 * width / this.innerWidth;
  
              } 
            } 
            
          

            data.width = calcW + 'vw';
          } */


          this.dataSetDesc[data.dataField] = ''
          if (data.type == 'campoComponent') {
            //////////console.log('IS DYNAMIC:', data['dynamic'])

            options[data.dataField] = {
              campo: 'CampoComponent'
            }
            //this.dataSet[data.dataField] = 'gggggggggggg'
          }
          if (data.type == 'campoDesc') {
            //////////console.log('IS DYNAMIC:', data['dynamic'])


            //this.dataSet[data.dataField] = 'gggggggggggg'
          }
          if (data.type == 'campoDesc') {
            //////////console.log('IS DYNAMIC:', data['dynamic'])


            //this.dataSet[data.dataField] = 'gggggggggggg'
          }

          if (data.dynamic && data.type == 'campoSpecial') {
            //////////console.log('IS DYNAMIC:', data['dynamic'])


            options[data.dataField] = this.generateNewItemOptions(data, data.dataField);
          }

          if (data.lookup) {
            ////////console.log('IS LOOKUP:', data['lookup'])
            options[data.dataField] = this.generateNewItemLookup(data, data.dataField);
          }

          if (data.lista) {


            options[data.dataField] = this.generateNewItemLista(data, data.dataField);


          }

          if (data.tagBoxList) {
            ////////console.log('tagBoxList:', data['tagBoxList'])
            options[data.dataField] = this.generateNewItemTagBox(data, data.dataField);
          }

          if (data.checkBox) {
            options[data.dataField] = this.generateNewItemCheckBox(data, data.dataField);
          }

          if (data.button || data.buttons) {
            //////////console.log('IS BUTTON:', data['lista'])
            if (data.type == 'campoButton') {
              options[data.dataField] = this.generateNewItemWithButton(data, data.dataField);
            } else if (data.type == 'simpleButton') {
              options[data.dataField] = this.generateNewItemButton(data, data.dataField);
            }



          }


          if (data.type == 'campoImmagine') {

            //options[data.dataField] = this.getDynamicImage(data);

          }

          if (data.autocomplete && data.type == 'campoSpecial') {
            options[data.dataField] = this.generateNewItemAutocomplete(data, data.dataField);
          }

          if (data.type == 'campoComponent') {
            this.showDynamicComponent(data)
          }
          if (data.dataType == 'date') {
            let initValue = null;
            options[data.dataField] = {
              showClearButton: data.showClearButton,
              useMaskBehavior: true,
              displayFormat: data.format,
              dateSerializationFormat: 'yyyy-MM-dd',
              width: data.width,
              type: data.dataType,
              class: data.class,
              showDropDownButton: data.showDropDownButton,
              showAnalogClock: false,
              readOnly: data.readOnly,
              disabled: data.disabled,
              inputAttr: {
                id: data.dataField,
                autocomplete: 'chrome-off', // 'off' //'new-password'
                readonly: data.readonly || data.disableOnUpdate ? 'readonly' : '',
                class: data.disableOnUpdate ? 'disabled ' + data.editorClass : data.editorClass,
                alt: this.dataSet[data.dataField],
                style: data.attr,
                size: (data.maxLength && !data.maxSize) ? data.maxLength : data.maxSize
              },
              onValueChanged: ($event) => {
                let dataToSend = {
                  value: $event.value,
                  previousValue: $event.previousValue,
                  campo: data,
                  formData: this.formEdit.formData,
                  component: $event.component,
                  masterComponent: this.formEdit.instance,
                  name: 'onValueChange'
                }

                this.emittendButtonPush.emit(dataToSend);
              },
              onInitializzed: ($event) => {

                if (data.defaultValue == 'now') {
                  initValue = new Date();
                  $event.component.value = initValue

                }
              }

            }
          }


          if (data.dataType == 'datetime') {
            let initValue = null;
            options[data.dataField] = {
              showClearButton: data.showClearButton,
              useMaskBehavior: true,
              displayFormat: data.format,
              dateSerializationFormat: 'yyyy-MM-ddTHH:mm:ss',
              width: data.width,
              type: data.dataType,
              class: data.class,
              showDropDownButton: data.showDropDownButton,
              showAnalogClock: false,
              readOnly: data.readOnly,
              disabled: data.disabled,
              inputAttr: {
                id: data.dataField,
                autocomplete: 'chrome-off', // 'off' //'new-password'
                readonly: data.readonly || data.disableOnUpdate ? 'readonly' : '',
                class: data.disableOnUpdate ? 'disabled ' + data.editorClass : data.editorClass,
                alt: this.dataSet[data.dataField],
                style: data.attr,
                size: (data.maxLength && !data.maxSize) ? data.maxLength : data.maxSize
              },
              onValueChanged: ($event) => {
                let dataToSend = {
                  value: $event.value,
                  previousValue: $event.previousValue,
                  campo: data,
                  formData: this.formEdit.formData,
                  component: $event.component,
                  masterComponent: this.formEdit.instance,
                  name: 'onValueChangedDateTime'
                }

                this.emittendButtonPush.emit(dataToSend);

              },
              onInitializzed: ($event) => {

                if (data.defaultValue == 'now') {
                  initValue = new Date();
                  $event.component.value = initValue

                }


              }

            }
          }
          if (data.dataType == 'time') {
            options[data.dataField] = {
              showClearButton: data.showClearButton,
              interval: 15,
              useMaskBehavior: true,
              displayFormat: data.format,
              dateSerializationFormat: data.mask,
              width: data.width,
              type: data.dataType,
              class: data.class,
              disabled: data.disabled,
              inputAttr: {
                id: data.dataField,
                autocomplete: 'chrome-off', // 'off' //'new-password'
                readOnly: data.disableOnUpdate,
                class: data.disableOnUpdate ? 'disabled ' + data.editorClass : data.editorClass,
                alt: this.dataSet[data.dataField],
                style: data.attr,
                size: (data.maxLength && !data.maxSize) ? data.maxLength : data.maxSize
              },
              onValueChanged: ($event) => {
                var options = { hour: 'numeric', minute: '2-digit' };


                // let time = $event.value.toLocaleTimeString();

                ////console.log(time)
                //this.dataSet[data.dataField] = time
              }
            }
          }



          if (data.type == 'group' && data.items) {
            //Crea  le caratteristiche del bottone aggiungi item runtime & gli items
            this.dataGroupItems[data.dataField] = data.items

            options[data.dataField] = this.generateNewItemGroupButton(data, data.dataField);


          }
          if (data.radioGroup) {
            //Crea  le caratteristiche del bottone aggiungi item runtime & gli items
            this.dataGroupItems[data.dataField] = data.items

            options[data.dataField] = this.generateNewItemRadio(data, data.dataField);


          }
          if (data.autocomplete) {
            //Crea  le caratteristiche del bottone aggiungi item runtime & gli items
            this.dataGroupItems[data.dataField] = data.items

            options[data.dataField] = this.generateNewItemAutocomplete(data, data.dataField);


          }

        })

    }
    //  //////////console.log(options)

    return options;
  }

  generateNewItemOptions(campo, i) {
    var valueSerch = ''
    var valueCampo

    return {
      elementAttr: campo,
      width: campo.width,
      valueChangeEvent: "keyup",
      mask: campo.mask,
      maxLength: campo.maxLength,
      mode: campo.dataType,
      format: campo.format,
      opened: false,
      disabled: campo.disabled,
      readOnly: campo.readonly,
      placeholder: !campo.disabled ? campo.placeHolder : '',
      inputAttr: {
        acceptOnlyCharacters: campo.acceptOnlyCharacters,
        id: campo.dataField,
        autocomplete: 'off', // 'off' //'new-password'
        readonly: campo.readonly || campo.disableOnUpdate ? 'readonly' : '',
        class: campo.disableOnUpdate ? 'disabled ' + campo.editorClass : campo.editorClass,
        alt: this.dataSet[campo.dataField],
        style: campo.attr,
        /* size: (campo.maxLength && !campo.maxSize) ? campo.maxLength : campo.maxSize */

      },
      onInitialized: ($event) => {
        ////console.log('onInitializzed ' + campo.dataField, $event.component.option())

        setTimeout(() => {
          if (!campo.dynamic.autocomplete) {

            if (campo.dynamic.valueExpr != '' && typeof $event.event == 'undefined') {

              let value
              if (typeof this.dataSet[campo.dataField] != 'undefined') {
                value = this.dataSet[campo.dataField]
              } else {
                value = this.dataJson[campo.dataField]
              }
              if (value != '') {
                this.getElementValue(value, campo, 'onInit')
              }
              return

            }

          }

        }, 300);

      },


      onFocusOut: ($event) => {
        let valueCampo = $event.component.option('value')

        let dataToSend = {
          value: valueCampo,
          campo: campo,
          formData: this.formEdit.formData,
          component: $event.component,
          masterComponent: this.formEdit.instance,
          name: 'onFocusOut'
        }

        this.emittendButtonPush.emit(dataToSend);


        if (!campo.dynamic.autocomplete) {
          /***SE IL VALUEEXPR E IMPOSTATO FARE LA CHIAMATA getElementValue PER OTTENERE LA DESCRIZIONE NEL CAMPO RELAZIONATO***/
          if (campo.dynamic.valueExpr != '') {


            this.getElementValue(valueCampo, campo, 'onFocusOut')
            return
          }



        } else {
          if (valueCampo != null) {
            if (typeof campo.dynamic.checkValue != 'undefined') {


              if (!campo.dynamic.checkValue.forceInsert) {
                //$event.component.option('value',null)
                if (this.searchData.length > 0 && this.searchDataShow) {
                  let data = {
                    itemData: this.searchData[0]
                  }
                  this.setAutoCompliteValue(data);
                  this.searchDataShow = false
                } else if (this.searchData.length == 0 && this.searchDataShow) {
                  $event.component.option('value', null);
                  this.searchDataShow = false
                }

              }
            } else {
              if (this.searchData.length == 0 && this.searchDataShow) {
                $event.component.option('value', null);
                this.searchDataShow = false
              }
            }

          }
        }



      },
      onFocusIn: ($event) => {
        let valueCampo = $event.component.option('value');
        let dataToSend = {
          value: valueCampo,
          campo: campo,
          formData: this.formEdit.formData,
          component: $event.component,
          masterComponent: this.formEdit.instance,
          name: 'onFocusIn'
        }

        this.emittendButtonPush.emit(dataToSend);
      },
      onChange: ($event) => {

        //console.log('onChange', $event)

        let valueCampo = $event.component.option('value')

        if (typeof campo.dynamic.checkValue != 'undefined')
          if (campo.dynamic.checkValue.forceInsert) {

            /*
              Constatato che si è presi la licenza poetica di complicare le cose (vedi analisti ingegneri GOOGLE APPLE e META della NICA), 
              ho deciso per non complicarmi la vita con controlli fantomatici che si faranno una sola volta nella vita...
              Il controllo e la verifica del comune, se è un comune esterò la faro nel controller ANASOGGETTO, sull'evento onChange 
              cit.DevExtreme <<A function that is executed when the UI component loses focus after the text field's content was changed using the keyboard.>>  
            */
            let dataToSend = {
              value: valueCampo,
              campo: campo,
              formData: this.formEdit.formData,
              component: $event.component,
              name: 'onChange'
            }

            this.emittendButtonPush.emit(dataToSend);




          }
      },


      /*onContentReady:($event) =>{
        ////////console.log('ci vai onContentReady',$event)
        valueCampo = $event.component.option('value');

        //////console.log('onContentReady ',valueCampo)
        if(campo.dynamic.valueExpr!=''){
          this.getElementValue(valueCampo,campo,);
        }
     
      },*/
      onKeyDown: ($event) => {

        console.log('onKeyDown', $event)
        //$event.event.stopPropagation();
        if (campo.disableOnUpdate) {
          $event.event.stopImmediatePropagation();
          $event.event.stopPropagation();
          $event.event.preventDefault();
        }
        //alert('onKeyDown : hai premuto il bottone: ' + $event.event.code,'code::')
        if (this.keyDown($event)) return;





        if ($event.event && $event.event.code === 'F3') {
          const data = $event.component.option('elementAttr');
          const componentType = campo.dynamic.componentType
          this.enableEditDynamicGrid = campo.dynamic.enableEditor ? true : false
          this.eventmitter(data, $event, componentType, campo.dynamic.dataSource, campo.dynamic.caption)
          $event.event.stopImmediatePropagation();
          $event.event.stopPropagation();
          $event.event.preventDefault();
        }
        if ($event.event.code == 'ArrowDown') {
          $event.event.stopImmediatePropagation();
          $event.event.stopPropagation();
          $event.event.preventDefault();
          let lista = this.staticList;
          let listItemSelect = lista.instance.option('selectedItemKeys');
          //console.warn((this.searchData as DataSource).store()['_array']); //KEY ITEMS
          if (this.searchData instanceof DataSource) {
            //console.warn(listItemSelect,this.indexPositionList);
            try {
              if (this.indexPositionList['group'] == 0 && this.indexPositionList['item'] == 0) {
                lista.instance.selectItem(this.indexPositionList);
                lista.instance.scrollToItem(this.indexPositionList);
                this.indexPositionList['item']++;
                return;
              }
              //if(this.staticList.items[this.indexPositionList['group']][this.indexPositionList['item']]){
              //console.warn(this.staticList.items);
              if (!this.staticList.items[this.indexPositionList['group']].items[this.indexPositionList['item'] + 1]) {
                this.indexPositionList['group']++;
                this.indexPositionList['item'] = 0;
                lista.instance.selectItem(this.indexPositionList);
                lista.instance.scrollToItem(this.indexPositionList);
                if (!this.staticList.items[this.indexPositionList['group']].items[this.indexPositionList['item']]) {
                  this.indexPositionList = {
                    group: this.staticList.items.length - 1,
                    item: this.staticList.items[this.staticList.items.length - 1].items.length - 1
                  };
                  console.error(this.indexPositionList);
                  lista.instance.selectItem(this.indexPositionList);
                  lista.instance.scrollToItem(this.indexPositionList);
                }
              }
              else {
                this.indexPositionList['item']++;
                lista.instance.selectItem(this.indexPositionList);
                lista.instance.scrollToItem(this.indexPositionList);
              }
            } catch (ex) {
              this.indexPositionList = {
                group: this.staticList.items.length - 1,
                item: this.staticList.items[this.staticList.items.length - 1].items.length - 1
              };
              lista.instance.selectItem(this.indexPositionList);
              lista.instance.scrollToItem(this.indexPositionList);
            }
            //}
            return;
            //lista.instance.selectItem({group:0 ,item:0});
          }
          else if (Array.isArray(this.searchData)) {
            if (listItemSelect.length < 0) {
              lista.instance.selectItem(0);
              return
            }
            let index
            let i = 0
            let g = 0
            if (this.searchData.find(searchData => searchData.items)) {

              if (listItemSelect.length > 0) {
                g = this.searchData.findIndex(fi => fi['key'] == listItemSelect[0].key);
              }
              let itemLen: number;

              itemLen = this.searchData[g].items.length;
              let gLen: number = this.searchData.length;
              this.searchData.forEach(element => {

                if (listItemSelect.length > 0) {

                  let c: number = element.items.findIndex(item => {

                    return item.id == listItemSelect[0].id
                  });
                  if (c > -1) {
                    i = c + 1;

                    return
                  }

                } else {
                  i = 0;
                }
                if (itemLen == i) {
                  g = g + 1;
                  i = 0
                }


              })

              if (g == gLen) {
                g = 0;
                i = 0;
              }


              index = { group: g, item: i };



            } else {
              index = this.searchData.findIndex(item => item['id'] == listItemSelect[0].id);

            }


            if (isNumber(index)) {
              g = index + 1;
              index = g;



            }


            if (this.searchData.length > 0 && g < this.searchData.length) {
              lista.instance.selectItem(index);
              lista.instance.scrollToItem(index)
            } else {
              lista.instance.selectItem(0);
              lista.instance.scrollToItem(0)
            }
          }
        }

        if ($event.event.code == 'ArrowUp') {
          const lista = this.staticList;
          let itemSelect = lista.instance.option('selectedItemKeys');
          //console.log(itemSelect)

          let index
          let items

          if (this.searchData instanceof DataSource) {


            try {


              if (!this.staticList.items[this.indexPositionList['group']].items[this.indexPositionList['item'] - 1]) {

                this.indexPositionList['group']--;
                this.indexPositionList['item'] = this.staticList.items[this.indexPositionList['group']].items.length - 1;

                lista.instance.selectItem(this.indexPositionList);
                lista.instance.scrollToItem(this.indexPositionList);

              }
              else {

                this.indexPositionList['item']--;
                lista.instance.selectItem(this.indexPositionList);
                lista.instance.scrollToItem(this.indexPositionList);


              }

            } catch (ex) {

              this.indexPositionList = {
                group: 0,
                item: 0
              };


              lista.instance.selectItem(this.indexPositionList);
              lista.instance.scrollToItem(this.indexPositionList);

            }


            //}


            return;

            //lista.instance.selectItem({group:0 ,item:0});


          }
          else if (Array.isArray(this.searchData)) {

            if (this.searchData.find(searchData => searchData.items)) {
              items = this.searchData.filter(searchData => { return searchData.items })
              index = items[0].items.findIndex(item => item['id'] == itemSelect[0].id);
              items = items[0].items;
            } else {
              index = this.searchData.findIndex(item => item['id'] == itemSelect[0].id);
              items = this.searchData
            }

          }



          index = index - 1;

          //console.log('keyUp', index);

          if (this.searchData.length > 0 && index > -1) {
            lista.instance.selectItem(index)
            //lista.instance.scrollToItem(0)
          } else {
            lista.instance.selectItem(0);
            //lista.instance.scrollToItem(0)
          }
        }



        if ($event.event.code == 'Enter') {

          const lista = this.staticList;
          let newItemSelect: any;

          if (this.searchData instanceof DataSource) {

            newItemSelect = this.staticList.selectedItems[0];


            if (newItemSelect['key'])
              this.setAutoCompliteValue({ itemData: newItemSelect['items'][0] });
            else
              this.setAutoCompliteValue({ itemData: newItemSelect });



          }
          else if (Array.isArray(this.searchData)) {


            newItemSelect = lista.instance.option('selectedItemKeys');
            newItemSelect.itemData = newItemSelect[0]


            this.setAutoCompliteValue(newItemSelect);
          }

          setTimeout(() => {
            this.searchData = [];
            this.searchDataShow = false;
          }, 300);


        }

      },
      onKeyUp: ($event) => {
        //$event.event.stopPropagation();



        //alert('onKeyUp : hai premuto il bottone: ' + $event.event.code,'code::')
      },

      onValueChanged: ($event) => {

        //Controllo se premo il backspace 

        if (campo.disableOnUpdate) {

          if (typeof $event.event != 'undefined') {
            if ($event.event.code == "Backspace") {
              if (!Array.isArray($event.value)) {
                if (Array.isArray($event.previousValue)) {
                  $event.component.option('value', $event.previousValue);
                  return
                }
              }
            }
          }
        }



        ////console.log('onValueChanged', $event)
        let value = $event.component.option('value')

        let hint = value;

        $event.component.option('hint', hint);


        if (campo.dynamic.autocomplete) {

          if (typeof $event.event != 'undefined') {

            if ($event.event.type != 'keyup') {
              ////console.log('noKeyPress', $event.value)
              return

            }
            let value = $event.value
            let event = $event;

            if (value.length > 0) {
              //this.showButtonTrash[campo.dataSource] = true;
              //L'unica soluzione che ho trovato per far apparire il bottone trash, ovvero richiamare la funzione getDynamiOptions
              //che serve per generare le opzioni di dxitem con bottone al suo interno.
              //this.itemOptions = this.getDynamicOptions(this.formData);

            }
            if (value.length >= 1 || value >= 1) {
              const data2 = $event.component.option('elementAttr');

              data2['valueSearch'] = value
              valueSerch = value



              //var buttons = $event.component.option('buttons');
              if (data2.dynamic.queryString && data2.dynamic.searchExpr.fatherDataField) {


                //let campoDaQueryString = (data2.namic.queryString as string).split('$')[1];




                if (!this.formEdit.formData[`${data2.dynamic.searchExpr.fatherDataField}`]) {

                  //let editor = this.formEdit.instance.getEditor(`${campoDaFiltrare}`);
                  //console.warn(editor,campoDaFiltrare)


                  //let htmlElement = (document.querySelectorAll(`div[datafield=${campoDaFiltrare}]`).item(0) as HTMLElement); //.getAttribute('caption');   

                  let caption: string = this.dataFields[data2.dynamic.searchExpr.fatherDataField].caption;

                  //console.warn(caption);

                  alert('Selezionare prima: ' + caption, 'Attenzione!');

                  this.formEdit.instance.updateData(data2.dataField, undefined);

                  return;

                }

              }


              this.keyPressAction(data2, event);





            } else {

              this.searchDataShow = false;
              //this.showButtonTrash[campo.dataSource] = false;
              this.searchData = []
            }
          } else {
            const data2 = $event.component.option('elementAttr');

            data2['valueSearch'] = value
            valueSerch = value

            //this.setElementValue(valueSerch,data2,$event.component)
          }
        }

        if (Array.isArray($event.value)) {
          let v = $event.value
          let value = $event.value.toString()

          let previousValue = $event.previousValue ? $event.previousValue.toString() : '';

          if (value == previousValue) {
            return
          }
          /*  if (campo.dynamic.related) {
             let  related = campo.dynamic.related
             related.forEach((valueR, key) => {
               let arrayValue = valueR.split('|')
               if (arrayValue.length > 1) {
                 this.dataSet[arrayValue[1]] = '';
                 this.formRefreshInputData(arrayValue[1], null)
               } else {
 
                 let valueRelated = this.dataSet[valueR];
                 let mappigRelated 
                 if(Array.isArray(valueRelated)){
                   v.forEach(res=>{
                     mappigRelated = valueRelated.map(reee=>{
                       if(reee[campo.dynamic.displayExpr] != res ){
                         return reee
                       }
                     })
                   })
 
                   this.formRefreshInputData(value,mappigRelated)
                   
                 }
 
 
                 this.formRefreshInputData(value, null)
               }
 
             })
           } */

        } else {
          let value = $event.value

          let previousValue = $event.previousValue ? $event.previousValue : '';

          if (value == previousValue) {
            return
          } else {
            if (!campo.dynamic.autocomplete) {

              if (campo.dynamic.valueExpr != '') {

                let value
                if (typeof this.dataSet[campo.dataField] != 'undefined') {
                  value = this.dataSet[campo.dataField]
                } else {
                  value = this.dataJson[campo.dataField]
                }
                if (value) {
                  //this.getElementValue(value, campo, 'onInit')
                }


              }

            }
          }

        }



        let dataToSend = {
          value: value,
          previousValue: $event.previousValue,
          campo: campo,
          formData: this.formEdit.formData,
          component: $event.component,
          masterComponent: this.formEdit.instance,
          thisComponent: this,
          name: 'onValueChanged'
        }

        this.emittendButtonPush.emit(dataToSend);
        if (NicaFormComponent.formDataBackupObject)
          if (($event.previousValue !== dataToSend.value) && NicaFormComponent.formDataBackupObject[campo.dataField] !== dataToSend.value) {



            dataToSend.name = 'valueDifferent';

            this.emittendButtonPush.emit(dataToSend);



          }
      },


      buttons: this.createItemButtons(campo, i)
    };
  }

  createItemButtons(campo, i) {
    let button = []
    if (typeof campo.dynamic != 'undefined') {

      if (typeof campo.dynamic.buttons != 'undefined') {
        button = campo.dynamic.buttons
      }

    } else if (campo.button) {
      button.push(campo.button)
    } else if (campo.buttons) {
      button = campo.buttons
    }

    let valueCampo = this.dataSet[campo.dataField];
    let returnButtons = [];
    if (button.length > 0) {
      const buttons = button

      buttons.forEach(button => {
        returnButtons.push({
          name: button.name,
          location: button.location,
          class: 'pippooooo',

          options: {
            text: button.text,
            stylingMode: 'text',
            elementAttr: campo,
            class: button.class,
            tabIndex: -1,
            hint: button.hint,
            icon: button.icon,
            visible: button.visible,
            onInitialized: ($event) => {
              //$($event.element).addClass("disabled-tab")
              //$event.component.content().classList.add("disabled-ta");
              //$event.element.addClass("disabled-tab")  
            },
            onClick: ($event) => {
              let emitted = {
                buttonEvent: $event,
                event: button.event,
                accesskey: button.accessKey,
                campo: campo,
                data: this.formEdit.formData,
                name: button.name
              }
              this.emittendButtonPush.emit(emitted)

            }
          }
        })


      })

    }

    if (typeof campo.dynamic != 'undefined') {
      if (typeof campo.dynamic.buttonOption != 'undefined') {

        button = campo.dynamic.buttonOption

        returnButtons = [...returnButtons, {
          name: campo.dynamic.buttonOption.name,

          location: campo.dynamic.buttonOption.location,
          class: 'pippooooo',

          options: {
            /*  text:button.text, */
            stylingMode: 'text',
            elementAttr: campo,
            class: 'pippooooo',
            tabIndex: -1,
            hint: campo.dynamic.buttonOption.hint,
            icon: campo.dynamic.buttonOption.icon,
            onInitialized: ($event) => {
              //$($event.element).addClass("disabled-tab")
              //$event.component.content().classList.add("disabled-ta");
              //$event.element.addClass("disabled-tab")  
            },
            onClick: ($event) => {

              const data = $event.component.option('elementAttr');

              const componentType = campo.dynamic.componentType
              this.enableEditDynamicGrid = campo.dynamic.enableEditor ? true : false;

              let form = this.formEdit.instance;
              let dataEditForm = form.option("formData");

              $event.name = 'beforeMitter';
              $event.formData = dataEditForm;
              $event.masterComponent = form;
              $event.campo = campo;
              $event.cancel = false

              this.emittendButtonPush.emit($event)

              if ($event.cancel) {
                $event.stopPropagation()
                return

              }





              this.eventmitter(campo, $event, componentType, campo.dynamic.dataSource, campo.dynamic.caption)

              $event.event.stopPropagation()
            },

          }
        },
        {
          name: 'trash',
          location: 'after',
          tabindex: -1,
          options: {
            stylingMode: 'text',
            elementAttr: campo,
            tabIndex: -1,
            visible: typeof campo.showClearButton != 'undefined' ? campo.showClearButton : true,
            hint: 'Pulisci campo',
            icon: 'mdi mdi-close-circle',
            onInitialized: ($event) => {
              //$($event.element).addClass("disabled-tab")
              //$event.component.content().classList.add("disabled-ta");
              //$event.element.addClass("disabled-tab")  
              this.showButtonTrash[campo.dataField] = false
            },
            onClick: ($event) => {
              let dataField = $event.component.option('elementAttr').dataField;
              let related = $event.component.option('elementAttr').dynamic.related;


              if (this.dataSet[dataField]) {
                this.dataSet[dataField] = null;
                valueCampo = null
                //this.formEdit.instance.getEditor(dataField);
                this.formRefreshInputData(dataField, null)
              }




              if (related) {
                related.forEach((value, key) => {
                  let arrayValue = value.split('|')
                  if (arrayValue.length > 1) {
                    this.dataSet[arrayValue[1]] = '';
                    this.formRefreshInputData(arrayValue[1], null)
                  } else {

                    this.dataSet[value] = '';
                    this.formRefreshInputData(value, null)
                  }

                })
              }
            }


          }
        }
        ]


      }
    }


    return returnButtons
    /*
          return  [{
            name: campo.dynamic.buttonOption.name,
            location: campo.dynamic.buttonOption.location,
    
            options: {
              stylingMode: 'text',
              elementAttr: campo,
              hint: campo.dynamic.buttonOption.hint,
    
              icon: campo.dynamic.buttonOption.icon,
              onClick: ($event) => {
    
                const data = $event.component.option('elementAttr');
                
                const componentType = campo.dynamic.componentType
                this.enableEditDynamicGrid = campo.dynamic.enableEditor ? true : false
                this.eventmitter(data, $event, componentType, campo.dynamic.dataSource, campo.dynamic.caption)
                //////////console.log($event.event)
                $event.event.stopPropagation()
              },
            },
          },
          {
            name: 'trash',
            location: 'after',
            options: {
              stylingMode: 'text',
              elementAttr: campo,
              
              hint: 'Pulisci campo',
              icon: 'mdi mdi-close-circle',
              onClick: ($event) => {
                let dataField = $event.component.option('elementAttr').dataField;
                let related = $event.component.option('elementAttr').dynamic.related;
    
    
                if (this.dataSet[dataField]) {
                  this.dataSet[dataField] = "";
                  this.showButtonTrash[i] = false
                  this.itemOptions = this.getDynamicOptions(this.formData);
                }
    
    
    
    
                if (related) {
                  related.forEach((value, key) => {
    
                    this.dataSet[value] = "";
    
                  })
                }
              }
    
    
            }
          }
          ]
        */
  }

  keyPressAction(data2: any, event) {

    console.warn(data2, event);


    this.searchData = [];
    let dataFinded = [];
    let caption = data2.dynamic.caption
    let dataSource = data2.dynamic.dataSource;
    let displayExpr = data2.dynamic.valueExpr ? data2.dynamic.valueExpr : data2.dynamic.displayExpr;
    let related = data2.dynamic.related
    let filter = data2.dynamic.filter
    let valueSearch = data2.valueSearch.toString().toLowerCase().replace("'", "''");
    let queryString = "";
    let $searchOdata = ''
    let qString = ''
    this.indexPositionList = { group: 0, item: 0 };

    //PROCEDURA PER ISEARCHEXPR
    if (typeof data2.dynamic.searchExpr == 'object') {

      if ((data2.dynamic.searchExpr as ISearchExpr).dataFields) {

        if ((data2.dynamic.searchExpr as ISearchExpr).expand)
          queryString = '($filter=(';
        else
          queryString = '$filter=(';

        let i = 0;

        for (let displayExpr of (data2.dynamic.searchExpr as ISearchExpr).dataFields) {

          if (!displayExpr.includes('data')) { // Pezzottissimo per le date


            if (i == 0)
              queryString += `(contains(tolower(${displayExpr}),'${(event.value as string).toLowerCase()}'))`;   //($filter=(contains(tolower(Descrizione), 'nica'))) 
            else
              queryString += ` or (contains(tolower(${displayExpr}),'${(event.value as string).toLowerCase()}'))`;   //($filter=(contains(tolower(Descrizione), 'nica'))) 


            i++;
          }
        }

        queryString += ')';

        /*
        if((data2.dynamic.searchExpr as ISearchExpr).expand)
          queryString += ')';
        */

        if ((data2.dynamic.searchExpr as ISearchExpr).optionalFilters) {


          for (let prop of Object.keys((data2.dynamic.searchExpr as ISearchExpr).optionalFilters)) {


            switch (typeof (data2.dynamic.searchExpr as ISearchExpr).optionalFilters[prop]) {

              case 'string':
                queryString += ` and (contains(tolower(${prop}),'${(data2.dynamic.searchExpr as ISearchExpr).optionalFilters[prop]}`;   //($filter=(contains(tolower(Descrizione), 'nica'))) 
                break;

              case 'boolean':
              case 'number':
                queryString += ` and ${prop} eq ${(data2.dynamic.searchExpr as ISearchExpr).optionalFilters[prop]} `;   //($filter=(contains(tolower(Descrizione), 'nica'))) 
                break;
            }



          }




        }

        if ((data2.dynamic.filterStatic as string) && !(data2.dynamic.searchExpr as ISearchExpr).expand) {

          if ((data2.dynamic.filterStatic as string).toLowerCase().includes('$filter='))
            queryString += 'and' + (data2.dynamic.filterStatic as string).split('$filter=')[1];
          else if ((data2.dynamic.filterStatic as string).toLowerCase().includes('?'))
            queryString = data2.dynamic.filterStatic + '&' + queryString;


        }


        if (data2.dynamic.queryString) {


          try {

            let campoDaFiltrare = (data2.dynamic.queryString as string).split('$')[1];

            //console.warn(this.formEdit.formData[`${campoDaFiltrare}`]);

            if (this.formEdit.formData[`${campoDaFiltrare}`]) {


              if ((data2.dynamic.queryString as string).includes('/'))
                data2.dynamic.queryString = `${(data2.dynamic.queryString as string).split('$')[0]}${this.formEdit.formData[`${campoDaFiltrare}`]}?`;
              else
                data2.dynamic.queryString = `${(data2.dynamic.queryString as string).split('$')[0]}${this.formEdit.formData[`${campoDaFiltrare}`]}&`;


            }


          } catch (ex) {

            console.warn(ex);

          }

        }


        if ((data2.dynamic.searchExpr as ISearchExpr).expand) //VEDERE SE CI SONO CASI IN CUI CI SONO SIA FILTER INTERNO SIA ESTERNO QUANDO ACCADE VEDERE QUI
          queryString = '?$expand=' + (data2.dynamic.searchExpr as ISearchExpr).expand + queryString + ')';
        else
          queryString = ((!data2.dynamic.queryString) ? '?' + queryString : (data2.dynamic.queryString as string) + queryString); //controllo se devo combinare il filtro querystring con quello dell searchexpr




        //console.warn("QUERY STRING",queryString);

        if (queryString.toLowerCase().includes('take'))
          queryString = `&$${queryString.split('$')[2]}`;


        let dataSource = data2.dynamic.dataSource;



        if (this.timeInterval > 0) {
          /// //console.log('timeInterval', this.timeInterval)

          clearTimeout(this.timeInterval);
          this.timeInterval = 0
          this.searchData = [];
          //event.component.option('readOnly', true);
        }

        this.timeInterval = setTimeout(() => {


          this.anagraficaService.getElenco(dataSource, filter, queryString).then(res => {


            let dataResults = [];

            if (res['items']) {
              dataResults = res['items'];
            } else {
              dataResults = (res as any[]);
            }

            let items = [];

            dataResults.forEach((dataRes: any) => {



              //data.related = related
              //data.dataField = data2.dataField
              //data.displayExpr = displayExpr

              //console.warn(dataRes);
              if ((data2.dynamic.searchExpr as ISearchExpr).expand) {
                if ((dataRes[`${(data2.dynamic.searchExpr as ISearchExpr).expand}`] as any[]).length > 0) {


                  if ((dataRes[`${(data2.dynamic.searchExpr as ISearchExpr).expand}`] as any[]).length > 0)
                    for (let obj of (dataRes[`${(data2.dynamic.searchExpr as ISearchExpr).expand}`] as any[])) {

                      obj[`group`] = dataRes[`${(data2.dynamic.searchExpr as ISearchExpr).headerField}`];
                      obj[`dataField`] = data2.dataField;
                      obj[`displayExpr`] = (data2.dynamic.searchExpr as ISearchExpr).dataFields;
                      obj['related'] = (data2.dynamic.searchExpr as ISearchExpr).related;

                      items.push(obj);

                    }

                  //items.push(dataRes);
                }
              }
              else if (!(data2.dynamic.searchExpr as ISearchExpr).expand) {


                dataRes['displayExpr'] = (data2.dynamic.searchExpr as ISearchExpr).dataFields;
                dataRes['related'] = (data2.dynamic.searchExpr as ISearchExpr).related;
                dataRes[`dataField`] = data2.dataField;
                dataRes['related'] = (data2.dynamic.searchExpr as ISearchExpr).related;

                items.push(dataRes);



              }

            });

            if (((data2.dynamic.searchExpr as ISearchExpr).expand)) {

              let store = new ArrayStore({
                data: items,
                key: (data2.dynamic.searchExpr as ISearchExpr).valueExpr,
              });

              this.searchData = new DataSource({
                store: store,
                key: (data2.dynamic.searchExpr as ISearchExpr).valueExpr,
                group: ((data2.dynamic.searchExpr as ISearchExpr).expand) ? 'group' : undefined,      //(data2.dynamic.searchExpr as ISearchExpr).expand,
              });

            }
            else {


              this.searchData = items;




            }

            console.warn(this.searchData, items);

            //////////console.log('eventSearch', event.element)

            let left = event.element.offsetLeft;
            let top = event.element.offsetTop;
            let height = event.element.offsetHeight;
            let width = event.element.offsetWidth;


            let element = document.querySelectorAll('[name=' + data2.dataField + ']').item(0);

            //console.warn(element);            

            this.elementTargetAuocomplete = '#' + element.id;           //element.getAttribute('id');



            //HO PROVATO SIA CON BIND(STA) SIA CON APPLY NON PUO FUNZIONARE PERCHè DEVEXTREME PASSA L'ITEM SOLO IN TEMPO REALE
            //this.displayExprAuocomplete.apply((data2.dynamic.searchExpr as ISearchExpr).dataFields);


            this.tempDataFields = (data2.dynamic.searchExpr as ISearchExpr).dataFields;


            this.groupAutocomplete = data2.dynamic.searchExpr.expand ? true : false
            this.widthTargetAuocomplete = width;
            this.heightTargetAuocomplete = 504;
            this.titleTargetAuocomplete = caption;
            this.searchDataShow = true;

            this.timeInterval = 0
            event.component.option('readOnly', false);
            /* document.getElementById("absoluteList").style.top = top + height + 'px';
             document.getElementById("absoluteList").style.left = left + 'px';
             document.getElementById("absoluteList").style.width = width + 'px';*/

            //document.getElementById("absoluteList").style.transform="translate("+left+"," +top +")"
            //////console.log(this.searchData)







          })

        }, 100);

        return;
      }

    }


    if (data2.dynamic.queryString) {



      if (data2.dynamic.queryString.includes('$')) {

        let arrQuerySTemp = data2.dynamic.queryString.split('$');

        let query = arrQuerySTemp[0];
        let filter = ''
        const dataSet = arrQuerySTemp[1].split('&')[0];

        if (typeof this.dataSet[dataSet] != 'undefined') {

          filter = this.dataSet[dataSet];
        }


        if (typeof filter != 'undefined') {
          qString = query + filter
        }

      } else {
        qString = data2.dynamic.queryString
      }


    }


    if (Array.isArray(data2.dynamic.displayExpr)) {
      data2.dynamic.displayExpr.forEach((searchS, i) => {

        if (searchS.includes('data')) {
          return
        }

        if (i == 0) {
          $searchOdata += "(contains(tolower(" + searchS + "),'" + valueSearch + "'))"
        } else {
          $searchOdata += " or (contains(tolower(" + searchS + "),'" + valueSearch + "'))"
        }

      })

    } else {
      $searchOdata = "(contains(tolower(" + data2.dynamic.displayExpr + "),'" + valueSearch + "'))";
    }


    if (dataSource.includes('?$filter')) {
      let source = dataSource.split('?');
      let finalString = ")"
      let orExpr = '';
      let newFilter = source[1].replace(')', '');
      if (data2.dynamic.searchExpr) {
        let addFilter = source[1].replace('$filter=', '')
        orExpr = " or " + addFilter + " and (contains(tolower(" + data2.dynamic.searchExpr + "),'" + valueSearch + "'))"
      }

      let separetor = ''
      if (qString.includes('?')) {
        separetor = "&";
      } else {
        filter = "?";
      }
      queryString = qString + separetor + newFilter + " and " + $searchOdata + orExpr + finalString;


      dataSource = source[0];
    } else {

      /*
      if (data2.dynamic.searchExpr) {
        let orExpr = ''
        orExpr = " or (contains(tolower(" + data2.dynamic.searchExpr + "),'" + valueSearch + "'))"
        let filterOdata = ''
        if (qString.includes('?')) {
          filterOdata = "&$filter=("
        } else {
          filterOdata = "?$filter=("
        }
        queryString = qString + filterOdata + $searchOdata + orExpr + ')';

      } else {
        let filter = ''
        let orderby = '$orderby=' + data2.dynamic.displayExpr + ' asc&';
        if (qString.includes('?')) {

          filter = "&" + orderby + "$filter=(" + $searchOdata + ')';
        } else {
          filter = "?" + orderby + "$filter=(" + $searchOdata + ')';
        }
        queryString = qString + filter
      }
      */
    }


    if (this.timeInterval > 0) {
      /// //console.log('timeInterval', this.timeInterval)

      clearTimeout(this.timeInterval);
      this.timeInterval = 0
      this.searchData = [];
      //event.component.option('readOnly', true);
    }

    this.timeInterval = setTimeout(() => {


      this.anagraficaService.getElenco(dataSource, filter, queryString).then(res => {

        let mydata
        if (res['items']) {
          mydata = res['items']
        } else {
          mydata = res
        }

        let items = [];
        mydata.forEach(data => {

          data.related = related
          data.dataField = data2.dataField
          data.displayExpr = displayExpr

          if (data2.dynamic.searchExpr) {
            let index = items.findIndex(res => res.key == data[data2.dynamic.searchExpr]);

            if (index > -1) {
              items[index].items.push(data);

            } else {
              items.push(
                {
                  key: data[data2.dynamic.searchExpr],
                  items: [data]
                }
              )

            }

          } else {
            items.push(data)
          }



        })
        ////console.log(items)
        this.searchData = items;



        if (valueSearch.length > 0 || valueSearch > 0) {
          //////////console.log('eventSearch', event.element)

          let left = event.element.offsetLeft;
          let top = event.element.offsetTop;
          let height = event.element.offsetHeight;
          let width = event.element.offsetWidth;

          let element = document.querySelectorAll('[name=' + data2.dataField + ']');

          this.elementTargetAuocomplete = '#' + element[0].getAttribute('id');



          // this.displayExprAuocomplete = displayExpr;
          this.groupAutocomplete = data2.dynamic.searchExpr ? true : false
          this.widthTargetAuocomplete = width;
          this.heightTargetAuocomplete = 504;
          this.titleTargetAuocomplete = caption;
          this.searchDataShow = true;

          this.timeInterval = 0
          event.component.option('readOnly', false);
          /* document.getElementById("absoluteList").style.top = top + height + 'px';
           document.getElementById("absoluteList").style.left = left + 'px';
           document.getElementById("absoluteList").style.width = width + 'px';*/

          //document.getElementById("absoluteList").style.transform="translate("+left+"," +top +")"
          //////console.log(this.searchData)

        } else {

          this.searchData = [];
          //////console.log(data2.dataField, this.searchData)
          this.searchDataShow = false;
          //this.dataSet[data2.dataField] = '';

          event.component.option('readOnly', false);

        }

        return



      })

    }, 100);
  }

  /**Setta il valore verificandone l'esistenza tramite API */
  setElementValue(value, campo, component) {

    let dataSource = campo.dynamic.dataSource;
    let displayExpr = campo.dynamic.valueExpr ? campo.dynamic.valueExpr : campo.dynamic.displayExpr;
    let related = campo.dynamic.related
    let queryParams = campo.dynamic.queryParams
    let valueSearch = value.toString().toLowerCase()

    this.anagraficaService.getElenco(dataSource, '', queryParams).then(res => {
      let mydata
      if (res['items']) {
        mydata = res['items']
      } else {
        mydata = res
      }

      let returnValue;
      mydata.filter(data => {

        if (data[displayExpr].toLowerCase() == valueSearch) {

          if (data) {
            this.dataSet[displayExpr] = data[displayExpr];
            returnValue = this.dataSet[displayExpr];
            //alert(returnValue,'ddd')
          }

        }

      })
      //console.log('returnValue--->', returnValue)
      component.option('value', returnValue)
      return returnValue

      this.searchData = [];
      this.searchDataShow = false;
      return
    })
  }
  /**Ottieni il valore tramite API */
  getElementValue(value, campo, evento) {
    //  //console.log( evento + ' - '+ value,campo.dataField)
    if (value) {
      let rel = ''
      if (!Array.isArray(value)) {

        let queryString
        if (campo.dynamic.queryString) {
          if (campo.dynamic.queryString.includes('$')) {
            let arrQuerySTemp = campo.dynamic.queryString.split('$');

            let query = arrQuerySTemp[0];
            let filter = ''
            const dataSet = arrQuerySTemp[1].split('&')[0];
            if (dataSet == campo.dataField) {
              filter = value;
              value = '';
            } else {
              if (typeof this.dataSet[dataSet] != 'undefined') {

                filter = this.dataSet[dataSet];
              }
            }


            /* if(arrQuerySTemp[1]=='value'){
              filter = value;
              value='';
            } */

            if (typeof filter != 'undefined') {
              queryString = query + filter
            }

          } else {
            queryString = campo.dynamic.queryString
          }
        }

        this.anagraficaService.getValue(campo.dynamic.dataSource, value, queryString).then(res => {



          if (res['items']) {
            res = res['items']
          }

          if (campo.costantValue) {
            campo.costantValue.forEach(values => {
              this.dataSet[values.key] = values.value;
            })
          }

          let newItem;
          if (!campo.dynamic.related) {
            return
          }
          campo.dynamic.related.forEach((value, key) => {
            let arrayValue = value.split('|')
            let displayValue = ''
            if (arrayValue.length > 1) {
              if (arrayValue[0].includes(',')) {
                const values = arrayValue[0].split(',');

                let lengthVal = values.length - 1

                values.forEach((val, index) => {

                  let separator = ''
                  if (index < lengthVal) {
                    separator = ' - '
                  }

                  let value = this.dateParse(res[val])
                  displayValue += value + separator;
                })
              } else {
                let value = this.dateParse(res[arrayValue[0]])
                displayValue = value
              }

              newItem = { ...this.dataSet, [arrayValue[1]]: displayValue };
            } else {
              if (value.includes(',')) {
                const values = value.split(',');

                let lengthVal = values.length - 1

                values.forEach((val, index) => {
                  let separator = ''
                  if (index < lengthVal) {
                    separator = ' - '
                  }
                  displayValue += res[val] + separator;
                })
              } else {
                displayValue = res[value]
              }
              newItem = { ...this.dataSet, [value]: displayValue };
            }
            this.dataSet = newItem
          })

          this.dataSetDesc[rel[1]] = res[campo.dynamic.displayExpr]
        }).catch(error => {
          //console.log(error)
          //alert('Valore inesistente', 'Attenzione!');
          this.dataSet[campo.dataField] = null;
          this.formEdit.instance.updateData(campo.dataField, null)

          const editor = this.formEdit.instance.getEditor(campo.dataField);

          editor.focus();

          let related = campo.dynamic.related;


          if (related) {
            related.forEach((value, key) => {
              let arrayValue = value.split('|')
              if (arrayValue.length > 1) {
                this.dataSet[arrayValue[1]] = '';
                this.formEdit.instance.updateData(arrayValue[1], null)
              } else {
                this.dataSet[value] = '';
                this.formEdit.instance.updateData(value, null)
              }

            })
          }


          return

        })
      } else {
        //////console.log('ci vai',campo.dynamic.related )
        let newItem = [];
        let related = campo.dynamic.related
        if (related) {
          campo.dynamic.related.forEach((relValue, key) => {
            let arrayValue = relValue.split('|');



            for (var i = 0; i < value.length; i++) {

              if (value[i][arrayValue[0]]) {

                newItem.push(value[i][arrayValue[0]])
              }
            }

            ////console.log('newItem',newItem)
            this.dataSet[arrayValue[1]] = newItem
          })

        }



        ///if(related)


        /*related.forEach((relatedValue, key) => {
          let arrayValue = relatedValue.split('|')
          if (arrayValue.length > 1) {
            //////console.log(arrayValue)
            //////console.log(value.filter(r=>r[arrayValue[0]]))
            let mappedFilter = value.filter(res=>{
              //////console.log(res[arrayValue[0]])
              return res[arrayValue[0]]
  
              
              
            })
           
            newItem = { ...this.dataSet, [arrayValue[1]]: mappedFilter.join(',') };
          } else {
            /*let mappedFilter = value.map(res=>{
              
              return res[arrayValue]
  
              
              
            })
            newItem = { ...this.dataSet, [arrayValue]: mappedFilter.join(',') };
          }                 
          this.dataSet = newItem  
        })*/

      }

    }

  }

  setAutoCompliteValue(ev) {



    //Se viene fatto con la ISearchExpr con expand!
    if (ev.itemData.group && ev.itemData.dataField && ev.itemData.displayExpr) {

      //this.formEdit.formData[ev.itemData.dataField] = 

      let finalResult = '';
      let allData = ev.itemData;

      if (Array.isArray(ev.itemData.displayExpr))
        for (let display of ev.itemData.displayExpr) {

          finalResult += ev.itemData[display] + ' ';

        }
      else if (typeof ev.itemData.displayExpr == 'string')
        finalResult = ev.itemData[ev.itemData.displayExpr];

      this.formEdit.instance.updateData(ev.itemData.dataField, finalResult);


      if (ev.itemData.related) {
        let related = ev.itemData.related;
        let newItem;
        let newItemDesc;
        related.forEach(value => {
          //////console.log(value)
          let arrayValue = value.split('|')
          if (arrayValue.length > 1) {
            newItem = { ...this.dataSet, [arrayValue[1]]: allData[arrayValue[0]] };
            newItemDesc = { ...this.dataSetDesc, [arrayValue[1]]: allData[arrayValue[0]] };

            this.formEdit.instance.updateData(`${arrayValue[1]}`, allData[arrayValue[0]]);


          } else {
            newItem = { ...this.dataSet, [value]: allData[value] };
            newItemDesc = { ...this.dataSetDesc, [value]: allData[value] };

            this.formEdit.instance.updateData(`${arrayValue[1]}`, allData[arrayValue[0]]);


          }

          this.dataSetDesc = newItemDesc

          this.dataSet = newItem



        })


      }

      return;
    }



    const itemData = ev.itemData;
    let displayExpr = itemData.displayExpr;
    const dataField = itemData.dataField;



    let stringValue = '';
    if (Array.isArray(displayExpr)) {

      itemData.displayExpr.forEach(dExpr => {

        let valueData = this.dateParse(itemData[dExpr])

        stringValue += valueData + ' ';
      })

    } else {

      let valueData = this.dateParse(itemData[displayExpr])
      stringValue = valueData;

    }

    const newItem = { ...this.dataSet, [dataField]: stringValue };

    this.dataSet = newItem;
    //////console.log('dataSet', itemData)
    let allData = itemData

    if (itemData.related) {
      let related = itemData.related
      let newItem;
      let newItemDesc;
      related.forEach((value, key) => {
        //////console.log(value)
        let arrayValue = value.split('|')
        if (arrayValue.length > 1) {
          newItem = { ...this.dataSet, [arrayValue[1]]: allData[arrayValue[0]] };
          newItemDesc = { ...this.dataSetDesc, [arrayValue[1]]: allData[arrayValue[0]] };

        } else {
          newItem = { ...this.dataSet, [value]: allData[value] };
          newItemDesc = { ...this.dataSetDesc, [value]: allData[value] };
        }

        this.dataSetDesc = newItemDesc

        this.dataSet = newItem

      })

    }

  }

  listPopOverContentReady($event) {
    const element = $event.element

    //$event.component.focus()

    //$event.component.selectItem(0);

    //$event.component.selectItem({group: 0, item: 0});

    if (this.searchData.length > 0 && this.searchDataShow) {
      ////console.log('dddddddddd',)
      $event.component.selectItem(0);
    }
  }



  displayExprAuocomplete(item) {


    let dataFields: string[] = this.tempDataFields;     //(this as any);


    if (dataFields) {
      let string = '';


      dataFields.forEach(dataField => {
        string += item[`${dataField}`] + ' ';   // item[display] + ' ';
      })

      return string;

    } else {
      return item[item.displayExpr]
    }

  }
  autoCompleteOut(e) {
    ////////////console.log(e)
    this.searchData = [];
    this.searchDataShow = false
  }

  generateNewItemLookup(campo, i) {
    this.getDataSourceVariable(campo);
    return
    return {
      width: campo.width,
      elementAttr: campo,
      closeOnOutsideClick: false,
      showClearButton: true,
      displayExpr: campo.lookup.displayExpr,
      valueExpr: campo.lookup.valueExpr,
      dataSource: this.getLookupsDataSource(campo.lookup, campo.dataSource),
      contentTemplate: 'contentLookup'
    };
  }

  /***LISTA***/

  generateNewItemLista(campo, i = '') {



    if (campo.lista.static) {
      let filter;

      if (typeof this.dataSet[campo.lista.filter] != 'undefined') {
        filter = this.dataSet[campo.lista.filter];
      }

      return {
        width: campo.width,
        dataSource: campo.lista.dataSource != '' ? this.formservice.getDati(campo.lista.dataSource, filter) : null,
        searchEnabled: true,
        showDropDownButton: campo.lista.showDropDownButton,
        placeholder: campo.lista.placeholder,
        items: campo.lista.items ? campo.lista.items : null,
        disabled: campo.disabled,
        inputAttr: {
          id: campo.dataField,
          autocomplete: 'off', // 'off' //'new-password'
          style: campo.attr,
          size: (campo.maxLength && !campo.maxSize) ? campo.maxLength : campo.maxSize,
          campo: campo,
          class: campo.editorClass,
          /*  readOnly:campo.readonly, */
        },
        showClearButton: campo.lista.showClearButton ? campo.lista.showClearButton : true,
        displayExpr: function (item) {
          if (item == null) {
            return
          }
          if (Array.isArray(campo.lista.displayExpr)) {
            let string = ''


            campo.lista.displayExpr.forEach(display => {
              string += item[display] + ' ';
            })

            return string;

          } else {
            return item[campo.lista.displayExpr]
          }

        },
        valueExpr: campo.lista.valueExpr,

        value: campo.defaultValue,
        readOnly: campo.readonly || campo.disableOnUpdate,

        onValueChanged: ($event) => {
          ////console.log('onValueChanged',$event);

          let emitData = {
            event: $event,
            campo: campo,
            value: $event.value,
            name: 'selectedItemLista',
            masterComponent: this.formEdit.instance,
            component: $event.component,
            dataField: campo.dataField,
            valore: $event.value,
            formData: this.formEdit.formData

          }

          this.emittendButtonPush.emit(emitData)

        },

      };
    } else {
      return {
        width: campo.width,
        dataSource: this.getLookupsDataSource(campo.lista, campo.dataField),
        searchEnabled: true,
        showDropDownButton: campo.lista.showDropDownButton,
        placeholder: campo.lista.placeholder,
        disabled: campo.disabled,
        inputAttr: {
          id: campo.dataField,
          autocomplete: 'chrome-off',
          style: campo.attr,
          campo: campo,
          class: campo.editorClass
        },
        showClearButton: campo.lista.showClearButton ? campo.lista.showClearButton : true,

        displayExpr: function (item) {
          if (item == null) {
            return
          }
          if (Array.isArray(campo.lista.displayExpr)) {
            let string = ''


            campo.lista.displayExpr.forEach(display => {
              string += item[display] + ' ';
            })

            return string;

          } else {
            return item[campo.lista.displayExpr]
          }

        },
        //campo.lista.displayExpr
        valueExpr: campo.lista.valueExpr,
        readOnly: campo.readonly || campo.disableOnUpdate,
        value: campo.defaultValue,



        onFocusOut: ($event) => {
          if (campo.editorType == 'dxAutocomplete') {

          }

        },

        onInitialized: ($event) => {

          if (campo.lista.selectFirstElement == true) {
            this.store[campo.dataField].load().done(data => {
              if (data && data.length > 0)
                this.dataSet[campo.dataField] = data[0][campo.lista.valueExpr]
            });
          }
          ////console.log('onInitialized',$event);

          $event.name = 'selectedOnInit'
          $event.campo = campo,
            this.emittendButtonPush.emit($event)


        },
        onSelectionChanged: ($event) => {
          ////console.log('onSelectionChanged', $event)
          //let value = $event.component.option('value');
          if ($event.selectedItem) {

            let newItem;
            if (campo.lista.related) {
              let selectedItem = $event.selectedItem
              campo.lista.related.forEach((value, key) => {
                let arrayValue = value.split('|')
                if (arrayValue.length > 1) {
                  newItem = { ...this.dataSet, [arrayValue[1]]: selectedItem[arrayValue[0]] };
                } else {
                  if (typeof selectedItem[value] != 'undefined')
                    newItem = { ...this.dataSet, [value]: selectedItem[value] };
                }
                this.dataSet = newItem
              })
              newItem = { ...this.dataSet, [campo.dataField]: selectedItem[campo.lista.valueExpr] };
              this.dataSet = newItem;

              ////console.log('onSelectionChanged', this.dataSet)

            }

            let emitData = {
              event: $event,
              masterComponent: this.formEdit.instance,
              component: $event.component,
              campo: campo,
              value: $event.selectedItem,
              name: 'selectedItemLista',
              dataField: campo.dataField,
              formData: this.formEdit.formData,
              valore: $event.selectedItem[campo.lista.valueExpr]
            }

            this.emittendButtonPush.emit(emitData)

            // //console.log(this.dataSet)
          }





        },
        onValueChanged: ($event) => {

          console.log('onValueChanged', $event);


          if (campo.lista.cascading) {
            campo.lista.cascading.forEach((value, key) => {
              let cascading = value.split('|')
              let editor = this.formEdit.instance.getEditor(cascading[1])
              let campoLista = editor.option('inputAttr').campo;
              editor.reset();
              if (campoLista.tagBoxList) {
                editor.option('dataSource', this.getLookupsDataSource(campoLista.tagBoxList, cascading[1]))
                if ($event.previousValue != this.dataSet[campo.dataField] && $event.previousValue != null) {
                  this.dataSet[cascading[1]] = null
                }
                //editor.option('value', this.dataSet[campoACascata]);
                editor.option('disabled', false);
              }
              if (campoLista.lista) {
                if (campoLista.lista.static) {
                  let filter;
                  if (campoLista.lista.filter) {
                    filter = this.dataSet[campo.dataField]
                  }
                  editor.option('dataSource', this.formservice.getDati(campoLista.lista.dataSource, filter))
                } else {
                  editor.option('dataSource', this.getLookupsDataSource(campoLista.lista, cascading[1]))
                  if ($event.previousValue != this.dataSet[campo.dataField] && $event.previousValue != null) {
                    this.dataSet[cascading[1]] = null
                    if (campoLista.lista.selectFirstElement == true)
                      this.store[cascading[1]].load().done(data => {
                        if (data && data.length > 0)
                          this.dataSet[cascading[1]] = data[0][campoLista.lista.valueExpr]
                      });
                  } else {
                    // this.dataSet[cascading[1]] = null
                    if (campoLista.lista.selectFirstElement == true)
                      this.store[cascading[1]].load().done(data => {
                        if (data && data.length > 0)
                          this.dataSet[cascading[1]] = data[0][campoLista.lista.valueExpr]
                      });
                  }
                  //editor.option('value', this.dataSet[campoACascata]);
                  editor.option('disabled', false);
                }
              }
              if (!$event.value) {

                //console.warn('provee', campo.dataField)

                this.formEdit.instance.updateData(campo.dataField, null);
                //editor.option('dataSource', this.getLookupsDataSource(campoLista.lista, cascading[1]))
                editor.option('value', null)
                //editor.option('disabled', true);
                editor.reset();

              }
            })
          }

          if (campo.lista.related) {
            let newItem;
            let selectedItem = $event.value;

            if (selectedItem != null) {
              campo.lista.related.forEach((value, key) => {
                let arrayValue = value.split('|')
                if (arrayValue.length > 1) {
                  if (!selectedItem[arrayValue[0]]) {
                    return
                  }
                  newItem = { ...this.dataSet, [arrayValue[1]]: selectedItem[arrayValue[0]] };
                } else {
                  if (!selectedItem[arrayValue[0]]) {
                    return
                  }
                  newItem = { ...this.dataSet, [value]: selectedItem[value] };
                }
                ////console.log('onValueChanged', newItem)
                this.dataSet = newItem

              })
            }
          }

          let emitData = {
            event: $event,
            campo: campo,
            value: $event.value,
            formData: this.formEdit.formData,
            name: 'ValueChangedLista',
            component: this.formEdit.instance
          }

          this.emittendButtonPush.emit(emitData)

        },
        onOpened: ($event) => {
          let dataSource = $event.component.option('items');
          if (dataSource.length == 0) {

            //            this.generateNewItemLista(campo, campo.dataField);
            //$event.component.option('dataSource', this.getLookupsDataSource(campo.lista, campo.dataField))

          }
          return
          if (campo.lista.cascading) {
            campo.lista.cascading.forEach((value, key) => {
              let cascading = value.split('|')
              let editor = this.formEdit.instance.getEditor(cascading[1])

              let campoLista = editor.option('inputAttr').campo;

              editor.reset();
              if (campoLista.lista.static) {

                let filter;
                if (campoLista.lista.filter) {
                  filter = this.dataSet[campo.dataField]
                }

                editor.option('dataSource', this.formservice.getDati(campoLista.lista.dataSource, filter))

              } else {


                editor.option('dataSource', this.getLookupsDataSource(campoLista.lista, cascading[1]))


                //editor.option('value', this.dataSet[campoACascata]);
                editor.option('disabled', false);


              }


            })

          }

        },
        onOptionChanged: ($event) => {

          console.log('onOptionChanged', $event)
        }


      };

    }

  }
  /***RADIO GROUP***/

  generateNewItemRadio(campo, i = '') {



    if (campo.radioGroup.static) {
      let filter;

      if (typeof this.dataSet[campo.radioGroup.filter] != 'undefined') {
        filter = this.dataSet[campo.radioGroup.filter];
      }

      return {
        width: campo.width,
        dataSource: campo.radioGroup.dataSource != '' ? this.formservice.getDati(campo.radioGroup.dataSource, filter) : null,
        layout: campo.radioGroup.layout,
        items: campo.radioGroup.items ? campo.radioGroup.items : null,
        inputAttr: {
          id: campo.dataField,
          autocomplete: 'off', // 'off' //'new-password'
          style: campo.attr,
          size: (campo.maxLength && !campo.maxSize) ? campo.maxLength : campo.maxSize,
          campo: campo,
          class: campo.editorClass,
        },

        displayExpr: campo.radioGroup.displayExpr,
        valueExpr: campo.radioGroup.valueExpr,
        disabled: campo.disableOnUpdate,


        onInitialized: ($event) => {

          if (typeof campo.defaultValue != 'undefined') {
            $event.component.option('value', campo.defaultValue)
          }


        },
        onValueChanged: ($event) => {
          //console.log('onValueChanged', $event);

          let emitData = {
            event: $event,
            campo: campo,
            value: $event.value,
            name: 'radioValueChanged',
            component: this.formEdit.instance
          }

          this.emittendButtonPush.emit(emitData)



        },

      };
    } else {
      let filter;

      if (typeof this.dataSet[campo.radioGroup.filter] != 'undefined') {
        filter = this.dataSet[campo.radioGroup.filter];
      }
      return {

        width: campo.width,
        dataSource: campo.radioGroup.dataSource != '' ? this.formservice.getDati(campo.radioGroup.dataSource, filter) : null,
        layout: campo.radioGroup.layout,
        items: campo.radioGroup.items ? campo.radioGroup.items : null,
        inputAttr: {
          id: campo.dataField,
          autocomplete: 'off', // 'off' //'new-password'
          style: campo.attr,
          size: (campo.maxLength && !campo.maxSize) ? campo.maxLength : campo.maxSize,
          campo: campo,
          class: campo.editorClass,
        },

        displayExpr: campo.radioGroup.displayExpr,
        valueExpr: campo.radioGroup.valueExpr,
        disabled: campo.disableOnUpdate,
        value: campo.defaultValue,



        onInitialized: ($event) => {

          ////console.log('onInitialized',$event);

          $event.name = 'radioOnInit'
          $event.campo = campo,
            this.emittendButtonPush.emit($event)


        },

        onValueChanged: ($event) => {





        }


      };

    }

  }

  generateNewItemTagBox(campo, i) {


    return {
      width: campo.width,
      opened: campo.tagBoxList ? campo.tagBoxList.opened : undefined,
      dataSource: this.getLookupsDataSource(campo.tagBoxList, campo.dataSource),
      searchEnabled: true,
      inputAttr: {
        id: campo.dataField,
        autocomplete: 'chrome-off',
        style: campo.attr,
        campo: campo,
        class: campo.disableOnUpdate ? 'disabled ' + campo.editorClass : campo.editorClass,
      },
      showClearButton: campo.tagBoxList.showClearButton,
      displayExpr: function (item) {
        if (item == null) {
          return
        }
        if (Array.isArray(campo.tagBoxList.displayExpr)) {
          let string = ''


          campo.tagBoxList.displayExpr.forEach(display => {
            string += item[display] + ' ';
          })

          return string;

        } else {
          return item[campo.tagBoxList.displayExpr]
        }

      },
      valueExpr: campo.tagBoxList.valueExpr,
      maxDisplayedTags: campo.tagBoxList.maxDisplayedTags,
      multiline: campo.tagBoxList.multiline,
      showDropDownButton: true,
      maxLength: "250px",

      showSelectionControls: campo.tagBoxList.showSelectionControls,
      applyValueMode: "useButtons",
      onInitialized: ($event) => {



        $event.name = 'selectedOnInitTag'
        $event.campo = campo,
          this.emittendButtonPush.emit($event)


      },
      onOpened: ($event) => {
        let emitData = {
          event: $event,
          component: this.formEdit.instance,
          campo: campo,
          //this.getLookupsDataSource(campo.tagBoxList, campo.dataSource),         
          //value: $event.selectedItem,
          name: 'onOpenedTag',
        }

        this.emittendButtonPush.emit(emitData)
      },
      onValueChanged: ($event) => {
        let value = ''
        if (typeof $event.value == 'undefined') {
          return
        }
        if (Array.isArray($event.value)) {
          if ($event.value.length > 0) {
            value = $event.value.toString();
          }

        }

        let prevValue = ''
        if (typeof $event.previousValue != 'undefined') {
          if (Array.isArray($event.previousValue)) {
            if ($event.previousValue.length > 0) {
              prevValue = $event.previousValue.toString()

            }
          }

        }

        if (value == prevValue) {
          return
        }
        //console.log('tagBoxList', $event)
        let emitData = {
          event: $event,
          component: this.formEdit.instance,
          campo: campo,
          value: $event.selectedItem,
          formData: this.formEdit.formData,
          name: 'selectedItemTag',
        }

        this.emittendButtonPush.emit(emitData)

      }


    };


  }
  generateNewItemCheckBox(campo, i) {


    return {
      width: campo.width,
      hint: campo.helpText,
      cssClass: campo.class,

      inputAttr: {

        id: campo.dataField,
        autocomplete: 'chrome-off',
        style: 'width:' + campo.width + 'px',
        class: campo.class
      },

      onValueChanged: ($event) => {

        if (campo.checkBox.event) {
          /*
              event:{
          type:'disabledItem',
          key:'tipoAutomezzo',
          value:'disabled'
        }
          */

          let event = campo.checkBox.event;

          if (event) {
            switch (event.type) {
              case 'disabledItem':
                //Poi lo farò dynamico se sono in componenttype
                if ($event.value) {

                  let editor = this.formEdit.instance.getEditor(event.key);
                  ////console.log(editor)
                  if (typeof editor != 'undefined') {
                    this.dataSet[event.key] = null;

                    editor.option('value', '');
                    event.value.forEach((option) => {
                      editor.option(option['optionName'], option['value']);
                    })
                  } else {


                    event.value.forEach((option) => {
                      this.dynamicComponentItem.settingsComponent['settingList']['disabled'] = false
                      //this.formEdit.instance.itemOption(event.key, option['optionName'], $event.value);

                    })

                  }

                  // editor.option('disabled',event.value)
                } else {

                  let editor = this.formEdit.instance.getEditor(event.key);
                  if (typeof editor != 'undefined') {
                    event.value.forEach((option) => {
                      editor.option(option['optionName'], null);
                    })
                  } else {
                    this.dataSet[event.key] = [];
                    this.dynamicComponentItem.dataInput[event.key] = []
                    this.dynamicComponentItem.settingsComponent['settingList']['disabled'] = true
                  }
                }

                break;

              case 'setTrueValue':
                //Poi lo farò dynamico se sono in componenttype
                let editor = this.formEdit.instance.getEditor(event.key);

                if ($event.value) {


                  let cValue = editor.option('value');
                  if (!cValue) {
                    if (typeof editor != 'undefined') {
                      this.dataSet[event.key] = null;

                      editor.option('value', '');
                      event.value.forEach((option) => {
                        editor.option(option['optionName'], option['value']);
                      })
                    }
                  }


                  // editor.option('disabled',event.value)
                } else {
                  /* let cValue = editor.option('value');
                  if (cValue) {
                    this.dataSet[event.key] = null;

                    editor.option('value', false);
                    
                  } */
                }

                break;

              case 'emittedEvent':

                let dataToSend = [];
                let dataEditForm = this.formEdit.instance.option("formData");
                ////console.log(dataEditForm)
                event.value.forEach((val) => {

                  dataToSend = {
                    ...dataToSend, [val.optionName]: dataEditForm[val.value]
                  }


                  //dataToSend.push(dataEditForm[value])
                })
                let eventEmitt = {
                  riferimento: campo,
                  event: $event,
                  evento: event.key,
                  dataToSend: dataToSend,
                  masterComponent: this.formEdit.instance

                }
                this.emittendButtonPush.emit(eventEmitt)

            }
          }
        }

      },



    };


  }

  generateNewItemAutocomplete(campo, i) {

    if (campo.autocomplete.static) {
      return {
        width: campo.width,
        dataSource: this.formservice.getDati(campo.autocomplete.dataSource),
        searchEnabled: true,
        inputAttr: {
          id: campo.dataField,
          autocomplete: 'chrome-off',
          style: 'width:' + campo.width + 'px',
          class: campo.disableOnUpdate ? 'disabled ' + campo.editorClass : campo.editorClass,
        },
        showClearButton: true,
        searchExpr: campo.autocomplete.displayExpr,
        valueExpr: campo.autocomplete.valueExpr,
        minSearchLength: campo.autocomplete.minSearchLength,
        maxLength: campo.maxLength,
        openOnFieldClick: true,
        showDropDownButton: false,
        placeholder: campo.placeHolder,

      };
    } else {

      return {
        width: campo.width,
        dataSource: this.getLookupsDataSource(campo.autocomplete, campo.dataField),
        searchEnabled: true,
        inputAttr: {
          id: campo.dataField,
          autocomplete: 'chrome-off',
          style: 'width:' + campo.width + 'px',
          class: campo.disableOnUpdate ? 'disabled ' + campo.editorClass : campo.editorClass,
        },
        showClearButton: true,
        displayExpr: campo.autocomplete.displayExpr,
        valueExpr: campo.autocomplete.valueExpr,
        minSearchLength: campo.autocomplete.minSearchLength,
        maxLength: campo.maxLength,
        openOnFieldClick: true,
        showDropDownButton: false,
        placeholder: campo.placeHolder,
        onSelectionChanged: ($event) => {

          ////console.log('onValueChanged', $event)
          if (campo.autocomplete.related) {
            let newItem;
            let selectedItem = $event.selectedItem;

            if (typeof selectedItem != null) {
              campo.autocomplete.related.forEach((value, key) => {
                let arrayValue = value.split('|')
                if (arrayValue.length > 1) {
                  if (!selectedItem[arrayValue[0]]) {
                    return
                  }
                  newItem = { ...this.dataSet, [arrayValue[1]]: selectedItem[arrayValue[0]] };
                } else {
                  if (!selectedItem[arrayValue[0]]) {
                    return
                  }
                  newItem = { ...this.dataSet, [value]: selectedItem[value] };
                }

                this.dataSet = newItem

              })
            }
          }


        }
      };




    }

  }

  getDataSourceVariable(data) {
    let filter = ''
    if (data.filterPath) {
      if (this.dataJson[data.lookup.filterPath])
        /*
          DATAJSON se ci sono dati di riferimento (idTabRif) passati alla form, 
          non ho usato dataSet perché non è stato ancora definito un data set per la FORM,
          sono ancora nell'inizzilizzazione del componente
        */
        filter = this.dataJson[data.lookup.filterPath]

    }

    let queryString = '';

    if (data.lookup.queryString) {
      if (data.lookup.queryString.includes('$')) {

        let arrQuerySTemp = data.lookup.queryString.split('$');

        let query = arrQuerySTemp[0];
        let filter = ''
        if (typeof this.dataSet[arrQuerySTemp[1]] != 'undefined') {
          filter = this.dataSet[arrQuerySTemp[1]];
        } else {
          filter = this.dataJson[arrQuerySTemp[1]]
        }
        this.dataSet[arrQuerySTemp[1]];
        if (typeof filter != 'undefined') {
          queryString = query + filter
        }

      } else {
        queryString = data.lookup.queryString
      }
    }


    this.dataSourceLookUp[data.dataField] = new CustomStore({
      loadMode: "raw",
      key: data.lookup.valueExpr,

      load: () => this.anagraficaService.getElenco(data.lookup.dataSource, filter, queryString).then(res => {
        ////////console.log('DataSourceLista---->',res['items'])
        if (res['items']) {
          res = res['items']
        } else {
          res = res
        }


        return res
      }),

    })
    this.lookUpValue[data.dataField] = [];
    this.rowSelectLookUp[data.dataField] = [];
    this.rowSelectedLookUp[data.dataField] = [];
    /*if(this.dataSet[data.dataField]){
 
     this.lookUpValue = this.dataSet[data.dataField].join(',');
     ////////console.log('lookUpValue', this.lookUpValue)
    }*/
  }
  getLookupsDataSource(data, dataField) {



    let filter = '';
    let queryString = ''
    if (data.filterPath) {
      if (this.dataJson[data.filterPath])
        /*
          DATAJSON se ci sono dati di riferimento (idTabRif) passati alla form, 
          non ho usato dataSet perché non è stato ancora definito un data set per la FORM,
          sono ancora nell'inizzilizzazione del componente
        */
        filter = '/' + this.dataJson[data.filterPath]

    }

    if (data.queryString) {


      if (data.queryString.includes('$filter')) {

        const string = /\$[a-zA-Z]*\b/gm;

        let ArradataStrig = data.queryString.match(string);

        //console.log('OdataStrig', ArradataStrig);
        let OdataStrig = ArradataStrig[0];
        let dataString = ''

        let arrQuerySTemp = ArradataStrig[1].split('$');
        let query = arrQuerySTemp[0];
        let filter = ''
        if (typeof this.dataSet[arrQuerySTemp[1]] != 'undefined') {
          filter = this.dataSet[arrQuerySTemp[1]];

          filter = data.queryString.replace(ArradataStrig[1], filter)
        }
        dataString = query + filter

        queryString = dataString
        //console.log('dataString', queryString)
      } else {

        if (data.queryString.includes('$')) {

          let arrQuerySTemp = data.queryString.split('$');

          let query = arrQuerySTemp[0];
          let filter2 = ''


          if (typeof this.dataSet[arrQuerySTemp[1]] != 'undefined') {
            filter2 = this.dataSet[arrQuerySTemp[1]];

          } else {

            if (typeof this.dataJson != 'undefined') {
              filter2 = this.dataJson[arrQuerySTemp[1]]
            }

          }

          //console.log("ecco le colonne ",this.formData)
          this.dataSet[arrQuerySTemp[1]];
          if (typeof filter2 != 'undefined') {
            if (!filter2) {
              return
            }
            queryString = query + filter2

            if (data.filter) {

              queryString = queryString.concat(data.filter);

              //console.warn(queryString,data);
            }

          }
          if (!queryString) {
            queryString = ''
          }
        } else {




          queryString = data.queryString.concat(data.filter ? data.filter : '')

          //Aggiungere il filter static dopo di querystring




        }
      }

    }


    return this.store[dataField] = new CustomStore({
      loadMode: "raw",
      key: data.valueExpr,
      onLoaded: (e) => {
        ////console.log("DATTTTTTTTTTTTTTTTTTTTTTTTTTTTTTAAAAAA ",data)      
        let x = {
          data: e,
          name: 'onLoaded',
          dataField: dataField,
          formData: this.formEdit.formData,
          masterComponent: this.formEdit.instance,
          datasource: this.store[dataField]
        };
        this.emittendButtonPush.emit(x)

      },
      load: () => this.anagraficaService.getElenco(data.dataSource, filter, queryString).then(res => {


        if (res['items']) {

          res = res['items']

        } else {

          res = res
        }
        return res
      }),


    })


  }

  generateNewItemWithButton(campo, i) {

    return {

      elementAttr: campo,
      width: campo.width,
      valueChangeEvent: "change",
      mask: campo.mask,
      maxLength: campo.maxLength,
      mode: campo.dataType,
      format: campo.format,
      disabled: campo.disabled,
      inputAttr: {
        id: campo.dataField,
        autocomplete: 'chrome-off', // 'off' //'new-password'
        readonly: campo.readonly || campo.disableOnUpdate ? 'readonly' : '',
        class: campo.disableOnUpdate ? 'disabled ' + campo.editorClass : campo.editorClass,

        style: campo.attr,
        size: (campo.maxLength && !campo.maxSize) ? campo.maxLength : campo.maxSize

      },

      buttons: this.createItemButtons(campo, i),
      onPaste: (event) => {
        console.warn(event)

        //if(this.formEdit)
        //this.formEdit.instance.updateData(campo.dataField,campo.value);

      },

      /*  [{
         text: campo.name,
         name: campo.button.name,
         location: campo.button.location,
 
         options: {
           stylingMode: 'text',
           elementAttr: campo,
           hint: campo.button.hint,
 
           icon: campo.button.icon,
           onClick: ($event) => {
 
             let dataEditForm = this.formEdit.instance.option("formData");
             if (typeof campo.button.outPutValue != 'undefined' && campo.button.outPutValue == true) {
 
 
               if (typeof dataEditForm[i] == 'undefined' || dataEditForm[i].length == 0 || dataEditForm[i] == '') {
                 alert('Nessun valore, il campo è vuoto ', 'Attenzione!')
                 return
               }
               let dataToSend = {
                 name: campo.button.name,
 
                 campo: campo,
                 campoButton: campo.button,
                 event: $event,
                 data: dataEditForm
               }
 
               this.emittendButtonPush.emit(dataToSend);
 
             } else {
 
               let dataToSend = {
                 name: campo.button.name,
                 campo: campo,
                 campoButton: campo.button,
                 event: $event,
                 data: dataEditForm
               }
               this.emittendButtonPush.emit(dataToSend)
             }
 
 
 
           },
         },
 
 
 
 
       }] */
    }
  }

  generateNewItemGroupButton(campo, i) {
    return {
      icon: 'add',
      text: 'Add Item',
      elementAttr: campo,

      hint: 'Pulisci campo',

      onClick: ($event) => {
        let dataField = $event.component.option('elementAttr').dataField;
        let items = $event.component.option('elementAttr').items
        let newItem = []
        for (let x = 0; x < items.length; x++) {
          items[x].index = items[x].index + 1
          //////console.log(items[x])
          newItem[x] = items[x]
        }

        newItem.forEach(element => {
          this.dataGroupItems[dataField].push(element)
        });

        //////console.log(this.dataGroupItems[dataField])

        return
      },
    }
  }


  generateNewItemButton(campo, i) {
    return {
      text: campo.button.text,
      name: campo.button.name,
      elementAttr: campo,
      icon: campo.button.icon,
      stylingMode: campo.button.type,
      hint: campo.button.hint,
      disabled: campo.button.disabled || campo.disabled,
      visible: campo.button.visible || campo.visible,
      onClick: ($event) => {

        const data = $event.component.option('elementAttr');



        const componentType = campo.button.componentType
        if (componentType) {
          this.enableEditDynamicGrid = campo.button.enableEditor ? true : false
          this.eventmitter(data, $event, componentType, i, campo.button.name)


        } else {
          const dataEditForm = this.formEdit.instance.option("formData");
          let dataToSend = {
            name: campo.button.name,
            campo: campo.button,
            event: campo.button.event,
            data: dataEditForm,
            component: $event.component,
            masterComponent: this.formEdit.instance
          }
          this.emittendButtonPush.emit(dataToSend)

          //this.emittendButtonPush.emit(campo.button.event)
        }
        $event.event.stopPropagation()
      }
    }
  }


  // Salvataggio
  saveForm() {
    let form = this.formEdit.instance;
    let dataEditForm = form.option("formData");

    if (this.formActionType == 'edit') {
      ////////////console.log('edit');

      this.anagraficaService.actionPut(this.ApiCall, dataEditForm).then(result => {

        this.dataSet = (result as any)

      });

    } else {
      //delete dataEditForm['id']
      let check = this.IsJsonString(dataEditForm)
      let jsonData;
      if (!check) {
        jsonData = { ...dataEditForm };
      } else {
        jsonData = dataEditForm;
      }

      this.anagraficaService.actionInsert(this.ApiCall, jsonData).then(result => {



        if (result['codeMessage'] == -1) {

          notify({
            message: result['descrMessage'],
            //message: 'Anagrafica salvata',
            height: 45,
            width: 250,
            position: 'center center'
          }, 'error', 3000);

          return false;
        }

      });

    }
  }
  onFormSubmit(e?) {


    let form = this.formEdit.instance;
    let dataEditForm = form.option("formData");



    if (dataEditForm['oraRegistrazioneAppoggio']) {

      //console.warn(dataEditForm['oraRegistrazioneAppoggio']);

      dataEditForm['oraRegistrazione'] = dataEditForm['oraRegistrazioneAppoggio'];

      delete dataEditForm['oraRegistrazioneAppoggio'];

    }


    if (this.SubjectCall == 'autista') {


      try {

        if (!this.formEdit.formData['isAutista'] && !this.formEdit.formData['isOperaio']) {


          alert('Si prega di spuntare almeno uno delle opzioni di tipo attività', 'Attenzione');

          return;

        }

        if (this.formEdit.formData['dataAssunzione'].split('T').length > 0)
          this.formEdit.formData['dataAssunzione'] = this.formEdit.formData['dataAssunzione'].split('T')[0]

        if (this.formEdit.formData['dataFineAssunzione'].split('T').length > 0)
          this.formEdit.formData['dataFineAssunzione'] = this.formEdit.formData['dataFineAssunzione'].split('T')[0]


        if (Date.parse(this.formEdit.formData['dataAssunzione']) > Date.parse(this.formEdit.formData['dataFineAssunzione'])) {

          alert('La data di fine assunzione è più recente della data di inizio assunzione', 'Attenzione');

          return;

        }
        else if (Date.parse(this.formEdit.formData['dataAssunzione']) == Date.parse(this.formEdit.formData['dataFineAssunzione'])) {

          alert('La data di fine assunzione coincide con la data di inizio assunzione', 'Attenzione');

          return;

        }
      }
      catch (ex) {



      }


    }



    /*if(this.parent){
      this.parent.callabckFunction(dataEditForm).then(res=>{ // funzione dovrebbere ritornare un json {result:boolean,message:string}
      if(res.result==false){
          if(res.message)
            alert(res.message,'Salvataggio Dati')
          return false;
          }      
        })
    }
   */


    const dataToSend = {
      component: form,
      data: dataEditForm,
      name: 'onSavingonFormSubmit'
    }

    // ******* Si dovrebbe delegare al componente padre *********************
    if (this.SubjectCall == 'GiacenzaRifiutiIniziali') {
      let GridComponent = this.arrNicaAnagrafica.toArray();
      for (let i = 0; i < GridComponent.length; i++) {
        if (GridComponent[i].dynamicGridComponent.instance.NAME == 'dxDataGrid')
          if (GridComponent[i].dynamicGridComponent.instance.hasEditData()) {
            alert('ATTENZIONE!! ci sono delle modifiche da confermare', 'Conferma dati')
            return false;
          }
      }

      if (!dataEditForm.listGiacenzaRifiutiInizialiDettagli) {
        alert('ATTENZIONE!! devi inserire almeno una riga di dettaglio', 'Conferma dati')
        return false
      }
      let prot = 0, noprot = 0;
      for (let i = 0; i < dataEditForm.listGiacenzaRifiutiInizialiDettagli.length; i++) {
        if (dataEditForm.listGiacenzaRifiutiInizialiDettagli[i].protocolloGiacenza > '')
          prot++; else noprot++;
      }
      if (noprot > 0 && noprot > 1) {
        alert('ATTENZIONE!! puoi inserire solo una riga dettagli senza protocollo', 'Conferma dati')
        return false
      }

      if (prot * noprot > 0) {
        alert('ATTENZIONE!! non puoi inserire righe con protocollo e senza contemporaneamente', 'Conferma dati')
        return false
      }
    }
    // *************************************************************




    //console.log('onFormSubmit', form);
    //console.log('dataEditForm', dataEditForm);

    if (this.SubjectCall == 'magazzinorifiuti') {
      if (typeof dataEditForm.magazzinoRifiutiCer != 'undefined') {


        let magazzinoRifiutiCer = dataEditForm.magazzinoRifiutiCer.filter(res =>
          res.cer != null
        )

        dataEditForm.magazzinoRifiutiCer = magazzinoRifiutiCer;
      }
    }

    if (this.SubjectCall == 'AlboAutomezzo') {
      if (typeof dataEditForm.alboAutomezzoCer != 'undefined') {
        let alboAutomezzoCer = dataEditForm.alboAutomezzoCer.filter(res =>
          res.cer != null
        )

        dataEditForm.alboAutomezzoCer = alboAutomezzoCer;
      }
    }



    if (this.formActionType == 'edit') {
      ////////////console.log('edit');

      this.anagraficaService.actionPut(this.ApiCall, dataEditForm).then(result => {

        ////console.log('edit', result);

        this.dataSet = (result as any)

        notify({
          message: 'Anagrafica salvata',
          height: 45,
          width: 250,
          position: 'center center'

        }, 'success', 3000);

        //Dopo salvataggio, invia i dati all'esterno per un refresh o altro...
        //Aggiungo un evento ai dati da ritornare dopo il savataggio

        let eventName = 'submittedEditOk';

        this.dataSet['eventName'] = eventName

        this.emittendButtonPush.emit(this.dataSet)



        //this.formRefresh(this.queryString)
      });

    } else {
      delete dataEditForm['id']
      let check = this.IsJsonString(dataEditForm)
      let jsonData;
      if (!check) {
        jsonData = { ...dataEditForm };
      } else {
        jsonData = dataEditForm;
      }

      this.anagraficaService.actionInsert(this.ApiCall, jsonData).then(result => {



        if (result['codeMessage'] == -1) {

          notify({
            message: result['descrMessage'],
            //message: 'Anagrafica salvata',
            height: 45,
            width: 250,
            position: 'center center'
          }, 'error', 3000);

          return false;
        } else {

          notify({
            message: 'Anagrafica salvata',
            height: 45,
            width: 250,
            position: 'center center'
          }, 'success', 3000);

          this.dataSet = (result as any);

          //Dopo salvataggio, invia i dati all'esterno per un refresh o altro...

          //aggiungo un evento ai dati da ritornare dopo il savataggio

          let eventName = 'submittedInsertOk';

          this.dataSet['eventName'] = eventName;
          this.dataSet['nameService'] = this.SubjectCall


          this.emittendButtonPush.emit(this.dataSet)
        }

      });

    }






  }
  IsJsonString(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }

  /***Fine Salvataggio***/

  validationCallbackFunction = (e) => {
    //P




    e.rule.isValid = false
    e.name = 'validationCallbackFunction'
    this.emittendButtonPush.emit(e);
    if (e.rule.isValid) {
      return true
    }
    return false
  }

  showDynamicComponent(data) {

    // let queryStringFilter = campo.dynamic.queryStringFilter;

    let queryString;

    const filerStatic = typeof data.dynamic.filterStatic != 'undefined' ? data.dynamic.filterStatic : '';

    if (data.dynamic.queryString) {
      if (data.dynamic.queryString.includes('&')) {
        queryString = data.dynamic.queryString
        let arrQuerySTemp = data.dynamic.queryString.split('&');
        arrQuerySTemp.forEach(reQuery => {
          if (reQuery.includes('$')) {
            let arrQuerySTemp = reQuery.split('$');
            let query = arrQuerySTemp[0];
            let filter = ''
            if (typeof this.dataSet[arrQuerySTemp[1]] != 'undefined') {

              filter = this.dataSet[arrQuerySTemp[1]];

              queryString = queryString.replace('$' + arrQuerySTemp[1], filter)
            } else if (typeof this.dataJson[arrQuerySTemp[1]] != 'undefined') {

              filter = this.dataJson[arrQuerySTemp[1]];

            }



            queryString = queryString.replace('$' + arrQuerySTemp[1], filter)



          }
        })
        data.dynamic.queryStringFilter = queryString;
        return
      }

      if (data.dynamic.queryString.includes('$')) {

        let arrQuerySTemp = data.dynamic.queryString.split('$');

        let query = arrQuerySTemp[0];
        let filter
        if (typeof this.dataSet[arrQuerySTemp[1]] != 'undefined') {
          filter = this.dataSet[arrQuerySTemp[1]];
          if (filter == null || filter == '') {

            alert('Selezionare prima: ' + arrQuerySTemp[1], 'Attenzione!');
            return
          }
        } else if (typeof this.dataJson[arrQuerySTemp[1]] != 'undefined') {

          filter = this.dataJson[arrQuerySTemp[1]];
          let checkFilter = filter.toString();

          if (checkFilter == '') {

            alert('Selezionare prima: ' + arrQuerySTemp[1], 'Attenzione!');
            return
          }

        }


        if (typeof filter != 'undefined') {
          queryString = query + filter + filerStatic;
        }

      } else {
        queryString = data.dynamic.queryString + filerStatic;
      }

      data.dynamic.queryStringFilter = queryString;
      return
    }
  }

  onValueChangeSimple(e) {

    try {

      let campo = e.component.option('inputAttr').campo;
      e.name = 'onValueChange';
      e.campo = campo;
      e.formData = this.formEdit.formData
      e.masterComponent = this.formEdit.instance
      this.emittendButtonPush.emit(e)

      if (!campo)
        return;

      if (!campo.patterns)
        return;

      let regExp: RegExp = new RegExp(campo.patterns);


      if (!(e.value as string).match(regExp) && e.value && e.value.length > 0) //Il valore non è valido
      {


        if (this.formEdit)
          this.formEdit.instance.updateData(campo.dataField, e.previousValue); //formedit era undefined ho dovuto bindare il metodo



      }

    } catch (ex) {

      console.warn(ex);
      //gestito

    }

  }
  onContentReadyForm(ev) {
    ////console.log('onContentReadyForm', ev)
  }
  formDataChanged(e) {
    //    console.log('formDataChanged', e)

    if (typeof this.comparisonTarget[e.dataField] != 'undefined') {
      this.compareValue = this.comparisonTarget[e.dataField];
    }
    if (e.value) {
      this.showButtonTrash[e.dataField] = true
    } else {
      this.showButtonTrash[e.dataField] = false
    }



    if (!this.dataSetCopy.hasOwnProperty(e.dataField)) {

      this.dataSetCopy[e.dataField] = e.value
      return
    }



    if (this.dataSetCopy[e.dataField] != e.value) {
      this.allDataChanged = { ...this.allDataChanged, [e.dataField]: e.value }
      this.dataSetCopy[e.dataField] = e.value
      let event = {
        name: 'formDataChanged',
        formDataChanged: this.allDataChanged,
        component: e.component,
        dataFields: e.dataField,
        e: e
      }
      this.emittendButtonPush.emit(event)
    } else {
      let event = {
        name: 'formDataChanged',
        formDataChanged: this.dataSet,// allDataChanged,
        component: e.component,
        dataFields: e.dataField,
        e: e
      }
      this.emittendButtonPush.emit(event)
    }









  }

  registerKeyHandle = (i) => {

    //////console.log(i.editorOptions)
    /*i.editorOptions.onInitialized = ($event) => {
      ////console.log($event)
      /*args.component.registerKeyHandler("backspace", function (e) {
        this.getNextEditor(args.dataField)
      });
    };*/

  };
  onFocusIn(e) {


    let campo = e.component.option('inputAttr').campo;

    let dataToSend = {
      value: this.dataSet[campo.dataField],
      campo: campo,
      formData: this.formEdit.formData,
      component: e.component,
      masterComponent: this.formEdit.instance,
      name: 'onFocusIn'
    }

    this.emittendButtonPush.emit(dataToSend);
  }

  enterKeyPress(event) {
    return
    let validation = this.formEdit.instance.validate();
    //////////console.log(validation)
    if (validation.isValid) {
      this.onFormSubmit(event)
    }
  }


  getNextEditor(dataField) {
    var items = this.formEdit.instance.option("items");
    var index = items.findIndex(function (item) {
      return item.dataField === dataField;
    });
    return this.formEdit.instance.getEditor(items[++index < items.length ? index : 0].dataField);
  }

  /***Funzioni pubbliche STEP FORM TAB STEP***/
  public reInitializzaed() {
    this.ngOnInit()
  }
  public formRefresh(filterKey: any) {



    if (filterKey != "undefined" && filterKey != '') {
      this.dataSet = [];
      this.dataSetCopy = [];
      this.allDataChanged = [];
      this.showForm = false
      this.formEdit.instance.resetValues();

      this.formActionType = 'edit'
      this.loader.show()
      setTimeout(() => {
        this.getData('', '', filterKey);
        this.loader.hide()
      }, 200);

      //this.itemOptions = this.getDynamicOptions(this.formData);
    }
  }

  public formRefreshInputData(key, value) {
    this.dataSetCopy[key] = value;

    this.formEdit.instance.updateData(key, value);

  }
  public checkDataField(key) {
    if (this.formEdit.instance.getEditor(key)) {
      return true;
    } else {
      return false;
    }
  }


  /***EVERTI STEP FORM TAB STEP***/
  public clickStep(action) {
    ////console.log(action)
    let tabs = this.formEdit.items[0]['tabs'];
    let currentIndex = this.formTabselectedIndex;
    let newIndex
    if (action == 'Avanti') {
      newIndex = this.formTabselectedIndex + 1
    }
    if (action == 'Indietro') {

      newIndex = this.formTabselectedIndex - 1
    }
    if (action == 'saltaTab') {

      newIndex = this.formTabselectedIndex + 1


    }



    if (newIndex < tabs.length && newIndex >= 0) {
      tabs[currentIndex].disabled = false
      tabs[newIndex].disabled = false;
      this.formTabselectedIndex = newIndex
    } else {
      tabs[0].disabled = false;

    }

  }

  /***FINE EVENTI FORM TAB STEP ***/

  /***Eventi griglia***/

  public SelectionRow(event: any) {


    if (event) {

      this.dataSet = event
      this.dataSetCopy = event;
      this.loadingVisible = false;

      this.renderTemplateForm();

    }


  }

  rowClickLookUp(event, campo) {
    ////////console.log(event)

    const keyVariable = campo.dataField;
    const valueArray = event.data;

    const valueExpr = campo.lookup.valueExpr

    const dataCheck = this.rowSelectLookUp[campo.dataField].find(rows => rows[valueExpr] == valueArray[valueExpr]);
    ////////console.log(dataCheck)

    if (!dataCheck) {
      this.rowSelectLookUp[campo.dataField].push(valueArray);
      this.rowSelectedLookUp[campo.dataField].push(valueArray[valueExpr]);
      ////////console.log(this.rowSelectedLookUp)
      ///this.lookUpValue.push(valueArray[valueExpr])

      this.lookUpValue[campo.dataField] = this.rowSelectedLookUp[campo.dataField].join(',');

      ////////console.log(this.lookUpValue)
    } else {

      let index = this.rowSelectLookUp[campo.dataField].findIndex(rows => { return rows[valueExpr] == valueArray[valueExpr] });

      ////////console.log(index )
      this.rowSelectLookUp[campo.dataField].splice(index, 1);
      this.rowSelectedLookUp[campo.dataField].splice(index, 1);

      this.lookUpValue[campo.dataField] = this.rowSelectedLookUp[campo.dataField].join(',');
    }



    const newItem = { ...this.dataSet, [keyVariable]: this.rowSelectLookUp[campo.dataField] };

    this.dataSet = newItem

  }

  getValueLookUp(dataValue, displayExpr) {
    let data = ['']
    if (dataValue) {
      data = dataValue.map(data => {
        ///////////console.log(dataValue)
        return data['id']
      })

      ////////console.log(data)


    }
    ////////console.log(data.toString())
    return data.toString();
  }

  //Select lista Complessa
  rowClickListaLookup(event, campo, data) {



    const keyVariable = campo.dataField;
    const valueArray = event.data;

    const valueExpr = campo.lista.valueExpr

    const newItem = { ...this.dataSet, [keyVariable]: valueArray[valueExpr] };

    this.dataSet = newItem

    this.lookUpValue[campo.dataField] = valueArray[valueExpr];
    this.rowSelectLookUp[campo.dataField] = valueArray

  }
  onValueChangedListaLookUp(event, campo) {

    /*
    console.warn('sto facendo prove:', {
      event, campo
    })
    */




    if (campo.lista.cascading) {
      campo.lista.cascading.forEach((value, key) => {
        let cascading = value.split('|')
        let editor = this.formEdit.instance.getEditor(cascading[1])

        if (!editor)
          return;

        let campoLista = editor.option('inputAttr').campo;

        editor.reset();

        if (!event.value) {

          editor.option('value', null)


        }


        if (campoLista.lista.static) {

          let filter;
          if (campoLista.lista.filter) {
            filter = this.dataSet[campo.dataField]
          }

          editor.option('dataSource', this.formservice.getDati(campoLista.lista.dataSource, filter))

        } else {
          if (event.value) {
            editor.option('dataSource', this.getLookupsDataSource(campoLista.lista, cascading[1]))
            editor.option('value', this.dataSet[cascading[1]])
            editor.option('disabled', false)
          }
        }


      })
    }
    let newItem
    if (campo.lista.related) {
      let selectedItem = this.lookUpValue[campo.dataField]
      campo.lista.related.forEach((value, key) => {
        let arrayValue = value.split('|')
        if (arrayValue.length > 1) {
          newItem = { ...this.dataSet, [arrayValue[1]]: selectedItem[arrayValue[0]] };
        } else {
          newItem = { ...this.dataSet, [value]: selectedItem[value] };
        }
        this.dataSet = newItem
      })
      newItem = { ...this.dataSet, [campo.dataField]: selectedItem[campo.lista.valueExpr] };
      this.dataSet = newItem;

      ////console.log('onSelectionChanged', this.dataSet)

    }



    event.component.close();


    let emitData = {
      event: event,
      campo: campo,
      value: (event.value !== undefined && event.value !== null) ? event.value : undefined,
      name: 'ValueChangedListaLookup',
      component: this.formEdit.instance
    }

    this.emittendButtonPush.emit(emitData)
  }


  listaLookUpDisplayExpr(displayExpr, item) {

    let value = ''
    if (Array.isArray(displayExpr)) {
      /* displayExpr.forEach(dis=>{
        value += item[dis] + '';  
      }) */
      value = item && `${item.descrizioneSoggetto} <${item.descrizione}>`;
    } else {
      value = displayExpr;
    }
    return value
  }

  openComponent(component, data) {


    let dataFilter

    let title = ''
    if (data.dynamic.costantValue) {

      const costantValue = data.dynamic.costantValue;
      let values
      costantValue.forEach(element => {
        let keyEle = element['key'];
        let val = ''
        if (typeof this.dataSet[element['value']] != 'undefined') {
          val = this.dataSet[element['value']]
        } else {
          val = element['value']
        }

        values = { ...values, [keyEle]: val }
      })
      dataFilter = JSON.stringify(values)

    }

    let settingGrid = {
      isEditable: false,
      allowUpdating: false,
      allowDeleting: false,
      allowAdding: false,
      selectionMode: 'single',
      tableHeight: '630',
      tableWidth: '700',
      remoteOperations: false,
      showFilter: false,
      colonne: [],
      idTable: '0',
      rowAlternationEnabled: true,
      showToolbarTop: false
    }

    let campoDynamic = data.dynamic;
    if (typeof campoDynamic.settingGrid != 'undefined') {
      let sGrid = campoDynamic.settingGrid;
      let isEditable = (sGrid.allowAdding || sGrid.allowDeleting || sGrid.allowUpdating) ? true : false;
      let showToolbarTop = isEditable ? true : false;
      let tableWidth = typeof sGrid.width == 'undefined' ? 700 : sGrid.width
      settingGrid = {
        isEditable: isEditable,
        allowUpdating: sGrid.allowUpdating,
        allowDeleting: sGrid.allowDeleting,
        allowAdding: sGrid.allowAdding,
        selectionMode: sGrid.selectionMode,
        tableHeight: sGrid.height,
        tableWidth: tableWidth,
        remoteOperations: sGrid.remoteOperations,
        showFilter: sGrid.showFilterSearch,
        colonne: sGrid.colonne,
        showToolbarTop: showToolbarTop,
        rowAlternationEnabled: sGrid.rowAlternationEnabled,
        idTable: Math.random().toString().replace("0.", ""),
      }

    }


    title = campoDynamic.caption
    let showCaptionFooter = true;
    let showToolbarBottom = false
    let showCaptionHeader = true;

    let popupWidth = data.dynamic.popupWidth ? data.dynamic.popupWidth : settingGrid.tableWidth;
    let popupHeight = data.dynamic.popupHeight ? data.dynamic.popupHeight : 600;

    if (settingGrid.selectionMode == 'multiple') {
      showCaptionFooter = false;
      showToolbarBottom = true;


    }

    if (campoDynamic.componentType != 'dynamicGrid') {
      showCaptionFooter = false;
      showToolbarBottom = true;
      showCaptionHeader = false;
      popupWidth = null
    }

    let queryString = ''
    if (typeof campoDynamic.queryString != 'undefined') {
      queryString = campoDynamic.queryString
    }




    const dataToSend = [{
      apiset: data.dynamic.dataSource,
      id: '',
      service: data.dynamic.service ? data.dynamic.service : null,
      InviaA: null,
      staticQueryFilter: data.dynamic.filterStatic,
      toolbarComponentFilter: null,
      filter: dataFilter,
      //campo:data,
      currentTabName: component,
      currentTabId: component,
      componentName: component

    }]




    let guid = Math.random().toString().replace("0.", "")
    this.userComponentService.setNewPopUp(guid, component, dataToSend, popupWidth, data, null, showCaptionFooter, showCaptionHeader, title);

    this.userComponentService.outputComponent.subscribe(currentOutput => {

      console.log('currentOutput', currentOutput);

      if (currentOutput.name == "onRowSelectionChange" && currentOutput.guid == guid) {

        const dataOutput = currentOutput
        const campo = currentOutput.accessoringData;
        let event = dataOutput;

        this.emittendButtonPush.emit(event);

        if (event.cancel) {
          return
        }

        this.updateFiedlFromGridSelection(dataOutput.data, campo, component);
        //alert("dddd","eeee")

      }

      //perchè uso nica anagrafica maaaa vedremo poi 
      if (currentOutput.name == "onSelectionChanged" && currentOutput.guid == guid) {

        const dataOutput = currentOutput
        dataOutput.campo = currentOutput.accessoringData
        let event = dataOutput;

        this.emittendButtonPush.emit(event);

        if (event.cancel) {
          return
        }

        this.updateFiedlFromGridSelection(currentOutput.data, currentOutput.accessoringData, component);
        //alert("dddd","eeee")

      }

      if (currentOutput.name == "masterDetailSelection" && currentOutput.guid == guid) {
        this.updateFiedlFromGridSelection(currentOutput.data, currentOutput.accessoringData, component);

      }

      if (currentOutput.name == "onRowExpanding" && currentOutput.guid == guid) {
        const dataOutput = currentOutput
        dataOutput.campo = currentOutput.accessoringData

        let event = dataOutput;
        this.emittendButtonPush.emit(event);
      }

      if (currentOutput.name == "onInitilized" && currentOutput.guid == guid) {
        const dataOutput = currentOutput
        dataOutput.campo = currentOutput.accessoringData
        let event = dataOutput;

        this.emittendButtonPush.emit(event);
      }

      if (currentOutput.name == "masterDetailInsert" && currentOutput.guid == guid) {

        /* 
          gestisco l'inserimento di un master detail di Nica anagrafica per poter personalizzare l'apertura e la chiusura del
          popUp dal componente Padre. In attesa di nuove idee o migliorie che mi verranno in mente più avanti
          
        */

        const dataOutput = currentOutput
        dataOutput.campo = currentOutput.accessoringData
        let event = dataOutput;

        this.emittendButtonPush.emit(event);
      }

      if (currentOutput.name == "masterDetailEdit" && currentOutput.guid == guid) {

        /* 
          gestisco l'inserimento di un master detail di Nica anagrafica per poter personalizzare l'apertura e la chiusura del
          popUp dal componente Padre. In attesa di nuove idee o migliorie che mi verranno in mente più avanti
          
        */

        const dataOutput = currentOutput
        dataOutput.campo = currentOutput.accessoringData
        let event = dataOutput;

        this.emittendButtonPush.emit(event);
      }
      if (currentOutput.name == "masterDetailInitilized" && currentOutput.guid == guid) {

        /* 
          gestisco l'inserimento di un master detail di Nica anagrafica per poter personalizzare l'apertura e la chiusura del
          popUp dal componente Padre. In attesa di nuove idee o migliorie che mi verranno in mente più avanti
          
        */

        const dataOutput = currentOutput
        dataOutput.campo = currentOutput.accessoringData
        let event = dataOutput;

        this.emittendButtonPush.emit(event);
      }

      //Eventi se sono ho una form

      if (currentOutput.eventName == 'submittedInsertOk' && currentOutput.guid == guid) {


        const dataOutput = currentOutput
        dataOutput.campo = currentOutput.accessoringData
        let event = dataOutput;

        this.emittendButtonPush.emit(event);
      }



    })
  }

  openComponentGrid(component, data) {


    let dataFilter

    let title = ''
    if (data.dynamic.costantValue) {

      const costantValue = data.dynamic.costantValue;
      let values
      costantValue.forEach(element => {
        let keyEle = element['key'];
        let val = ''
        if (typeof this.dataSet[element['value']] != 'undefined') {
          val = this.dataSet[element['value']]
        } else {
          val = element['value']
        }

        values = { ...values, [keyEle]: val }
      })
      dataFilter = JSON.stringify(values)

    }

    let settingGrid = {
      isEditable: false,
      allowUpdating: false,
      allowDeleting: false,
      allowAdding: false,
      searchAndSelect: false,
      selectionMode: 'single',
      tableHeight: '630',
      tableWidth: '700',
      remoteOperations: true,
      showFilter: false,
      colonne: [],
      idTable: '0',
      rowAlternationEnabled: true,
      showToolbarTop: false,
      showToolbarBottom: false,
      toolbarButtonsTopLeft: null,
      toolbarButtonsTopRight: null,
      toolbarButtonsBottomLeft: null,
      toolbarButtonsBottomRight: null,
      isOdata: true
    }

    let campoDynamic = data.dynamic;

    let isToolbarButtonsTop = false;
    let isToolbarButtonsBottom = false;


    if (typeof campoDynamic.settingGrid != 'undefined') {

      let sGrid = campoDynamic.settingGrid;
      let isEditable = (sGrid.allowAdding || sGrid.allowDeleting || sGrid.allowUpdating) ? true : false;
      let showToolbarTop = isEditable ? true : false;
      let tableWidth = typeof sGrid.width == 'undefined' ? 700 : sGrid.width;
      isToolbarButtonsBottom = typeof sGrid.toolbarButtonsBottomLeft != 'undefined' || typeof sGrid.toolbarButtonsBottomRight != 'undefined' ? true : false;
      isToolbarButtonsTop = typeof sGrid.toolbarButtonsTopLeft != 'undefined' || typeof sGrid.toolbarButtonsTopRight != 'undefined' ? true : false;

      settingGrid = {

        isEditable: isEditable,
        allowUpdating: sGrid.allowUpdating,
        allowDeleting: sGrid.allowDeleting,
        allowAdding: sGrid.allowAdding,
        selectionMode: sGrid.selectionMode,
        tableHeight: sGrid.height,
        tableWidth: tableWidth,
        remoteOperations: sGrid.remoteOperations,
        showFilter: sGrid.showFilterSearch,
        searchAndSelect: sGrid.searchAndSelect,
        colonne: sGrid.colonne,
        showToolbarTop: showToolbarTop,
        showToolbarBottom: sGrid.showToolbarBottom,
        rowAlternationEnabled: sGrid.rowAlternationEnabled,
        idTable: Math.random().toString().replace("0.", ""),
        toolbarButtonsTopLeft: sGrid.toolbarButtonstopLeft,
        toolbarButtonsTopRight: sGrid.toolbarButtonsTopRight,
        toolbarButtonsBottomLeft: sGrid.toolbarButtonsBottomLeft,
        toolbarButtonsBottomRight: sGrid.toolbarButtonsBottomRight,
        isOdata: sGrid.isOdata
      }

    }


    title = campoDynamic.caption
    let showCaptionFooter = true;
    let showToolbarBottom = false
    let showCaptionHeader = true;

    let popupWidth = data.dynamic.popupWidth ? data.dynamic.popupWidth : settingGrid.tableWidth;
    let popupHeight = data.dynamic.popupHeight ? data.dynamic.popupHeight : 600;

    let justSelectedData = [];

    if (settingGrid.selectionMode == 'multiple') {
      showCaptionFooter = false;
      showToolbarBottom = true;
      justSelectedData = this.dataSet[data.dataField]
    }

    if (campoDynamic.componentType != 'dynamicGrid') {
      showCaptionFooter = false;
      showToolbarBottom = true;
      showCaptionHeader = false;
      popupWidth = null
    }

    let queryString = ''
    if (typeof campoDynamic.queryString != 'undefined') {
      queryString = campoDynamic.queryString
    }

    if (isToolbarButtonsBottom) {
      settingGrid.showToolbarBottom = true;
      showToolbarBottom = false;
      showCaptionFooter = false
    }
    if (isToolbarButtonsTop) {
      settingGrid.showToolbarTop = true;
    }

    let detailOption = null

    if (typeof campoDynamic.detailOption != 'undefined') {

      let sGridDetail = campoDynamic.detailOption;


      detailOption = {
        isRemote: sGridDetail.isRemote,
        service: sGridDetail.service,
        api: sGridDetail.api,
        isEditable: sGridDetail.isEditable,
        costantValue: sGridDetail.costantValue,
        queryString: sGridDetail.queryString,
        colonne: sGridDetail.colonne

      }

    }



    let instancedDataGrid = {

      service: campoDynamic.service,
      api_rest: campoDynamic.api_rest,
      api: campoDynamic.dataSource,
      remoteOperation: settingGrid.remoteOperations,
      rowAlternate: true,
      dataJson: dataFilter,
      queryString: queryString,
      isEditable: settingGrid.isEditable,
      isEditableNewRow: settingGrid.allowAdding,
      isEditableEditRow: settingGrid.allowUpdating,
      isEditableDeleteRow: settingGrid.allowDeleting,
      tableHeight: settingGrid.tableHeight,
      tableWidth: settingGrid.tableWidth,
      showFilter: settingGrid.showFilter,
      colonne: settingGrid.colonne,
      selectionRowMode: settingGrid.selectionMode,
      selectedData: justSelectedData,
      showCaptionFooter: showCaptionFooter,
      showCaptionHeader: showCaptionHeader,
      idTable: settingGrid.idTable,
      showToolbarTop: settingGrid.showToolbarTop,
      isSearchable: settingGrid.searchAndSelect,
      showToolbarBottom: settingGrid.showToolbarBottom,
      toolbarButtonsTopLeft: settingGrid.toolbarButtonsTopLeft,
      toolbarButtonsTopRight: settingGrid.toolbarButtonsTopRight,
      toolbarButtonsBottomLeft: settingGrid.toolbarButtonsBottomLeft,
      toolbarButtonsBottomRight: settingGrid.toolbarButtonsBottomRight,
      detailOptions: detailOption,
      isOdata: settingGrid.isOdata
    }


    let dataToSend = null
    let campo = data

    let guid = Math.random().toString().replace("0.", "")
    this.userComponentService.setNewPopUp(guid, component, dataToSend, popupWidth, campo, instancedDataGrid, showCaptionFooter, showCaptionHeader, title);

    this.userComponentService.outputComponent.subscribe(currentOutput => {

      console.log('currentOutput', currentOutput);

      if (currentOutput.name == "onRowSelectionChange" && currentOutput.guid == guid) {

        const dataOutput = currentOutput
        const campo = currentOutput.accessoringData;
        let event = dataOutput;

        this.emittendButtonPush.emit(event);

        if (event.cancel) {
          return
        }

        this.updateFiedlFromGridSelection(dataOutput.data, campo, component);
        //alert("dddd","eeee")

      }

      //perchè uso nica anagrafica maaaa vedremo poi 
      if (currentOutput.name == "onSelectionChanged" && currentOutput.guid == guid) {

        const dataOutput = currentOutput
        dataOutput.campo = currentOutput.accessoringData
        let event = dataOutput;

        this.emittendButtonPush.emit(event);

        if (event.cancel) {
          return
        }

        this.updateFiedlFromGridSelection(currentOutput.data, currentOutput.accessoringData, component);
        //alert("dddd","eeee")

      }

      if (currentOutput.name == "masterDetailSelection" && currentOutput.guid == guid) {
        this.updateFiedlFromGridSelection(currentOutput.data, currentOutput.accessoringData, component);

      }

      if (currentOutput.name == "onRowExpanding" && currentOutput.guid == guid) {
        const dataOutput = currentOutput
        dataOutput.campo = currentOutput.accessoringData

        let event = dataOutput;
        this.emittendButtonPush.emit(event);
      }

      if (currentOutput.name == "onInitilized" && currentOutput.guid == guid) {
        const dataOutput = currentOutput
        dataOutput.campo = currentOutput.accessoringData
        let event = dataOutput;

        this.emittendButtonPush.emit(event);
      }

      if (currentOutput.name == "masterDetailInsert" && currentOutput.guid == guid) {

        /* 
          gestisco l'inserimento di un master detail di Nica anagrafica per poter personalizzare l'apertura e la chiusura del
          popUp dal componente Padre. In attesa di nuove idee o migliorie che mi verranno in mente più avanti
          
        */

        const dataOutput = currentOutput
        dataOutput.campo = currentOutput.accessoringData
        let event = dataOutput;

        this.emittendButtonPush.emit(event);
      }

      if (currentOutput.name == "masterDetailEdit" && currentOutput.guid == guid) {

        /* 
          gestisco l'inserimento di un master detail di Nica anagrafica per poter personalizzare l'apertura e la chiusura del
          popUp dal componente Padre. In attesa di nuove idee o migliorie che mi verranno in mente più avanti
          
        */

        const dataOutput = currentOutput
        dataOutput.campo = currentOutput.accessoringData
        let event = dataOutput;

        this.emittendButtonPush.emit(event);
      }
      if (currentOutput.name == "masterDetailInitilized" && currentOutput.guid == guid) {

        /* 
          gestisco l'inserimento di un master detail di Nica anagrafica per poter personalizzare l'apertura e la chiusura del
          popUp dal componente Padre. In attesa di nuove idee o migliorie che mi verranno in mente più avanti
          
        */

        const dataOutput = currentOutput
        dataOutput.campo = currentOutput.accessoringData
        let event = dataOutput;

        this.emittendButtonPush.emit(event);
      }

      if (currentOutput.name == "onRowMultipleSelectionChange" && currentOutput.guid == guid) {

        const dataOutput = currentOutput
        const campo = currentOutput.accessoringData;
        let event = dataOutput;

        this.emittendButtonPush.emit(event);

        if (event.cancel) {
          return
        }

        this.updateFiedlFromGridMultipleSelection(dataOutput.dataSelected, campo, component);
      }
      if (currentOutput.name == "annullaSelezione" && currentOutput.guid == guid) {

        const dataOutput = currentOutput
        const campo = currentOutput.accessoringData;
        let event = dataOutput;

        this.emittendButtonPush.emit(event);

        if (event.cancel) {
          return
        }

        this.userComponentService.destroyCurrentOpenPopUp(component)
        this.userComponentService.destroyOutputComponent()
      }



    })
  }

  eventmitter(dataz, event, componentType, dataSource, titleDynamic) {

    let isPureComponent = false;

    const factories = Array.from(this._componentFactoryResolver['_factories'].keys());
    const factoryClass = <Type<any>>factories.find((x: any) => x.name === componentType);
    if (typeof factoryClass != 'undefined') {
      if (factoryClass.name == componentType) {
        isPureComponent = true;
      }
    }

    if (componentType == 'dynamicGrid') {
      componentType = 'NicaDataGridComponent'
      isPureComponent = true;

    }


    if (isPureComponent) {
      if (typeof dataz.dynamic.queryString != 'undefined') {
        if (dataz.dynamic.queryString.includes('$')) {

          let arrQuerySTemp = dataz.dynamic.queryString.split('$');

          let query = arrQuerySTemp[0];
          let filter = ''
          if (typeof this.dataSet[arrQuerySTemp[1]] != 'undefined') {
            filter = this.dataSet[arrQuerySTemp[1]];

            this.formData.filter(res => res.dataField == arrQuerySTemp[1])
            if (filter == null || filter == '') {
              let ffff = this.dataFields[arrQuerySTemp[1]]



              alert('Selezionare prima: ' + ((ffff.caption) ? ffff.caption : arrQuerySTemp[1]), 'Attenzione!');
              return

            }
          }
        }
      }
      if (componentType == 'dynamicGrid' || componentType == 'NicaDataGridComponent') {
        componentType = 'NicaDataGridComponent'
        isPureComponent = true;
        this.openComponentGrid(componentType, dataz);
      } else {
        this.openComponent(componentType, dataz);
      }



      return
    }

    if (this.showDynamicContent) {

      return
    }
    //this.loader.show();

    /*this.height = (event.event.screenY) + 'px';
    this.width = (event.event.screenX) + 'px';*/
    if (event) {
      this.offsetX = event.event ? event.event.offsetX + 'px' : undefined;
      this.offsetY = event.event ? event.event.offsetY + 'px' : undefined;
    }


    let data = dataz;


    this.apiSource = '';

    this.componentData = '';

    /*
     @Input() apiSource:string;
     @Input() componentType:string;
     @Output() emittendSelectionRow;
    */

    this.apiSource = dataSource;
    this.titleDynamic = titleDynamic;
    this.filterKey = this.dataSet[data.dynamic.filter];



    this.componentType = componentType;
    this.componentData = data;


    let filter = '';
    let queryString = ''
    if (data.filterPath) {
      if (this.dataJson[data.filterPath])
        /*
          DATAJSON se ci sono dati di riferimento (idTabRif) passati alla form, 
          non ho usato dataSet perché non è stato ancora definito un data set per la FORM,
          sono ancora nell'inizzilizzazione del componente
        */
        filter = '/' + this.dataJson[data.filterPath]

    }

    const filerStatic = typeof data.dynamic.filterStatic != 'undefined' ? data.dynamic.filterStatic : '';

    if (data.dynamic.queryString) {
      if (data.dynamic.queryString.includes('$filter')) {
        //modifica del 11/09/2023
        const string = /\$[a-zA-Z]*\b/gm;

        let ArradataStrig = data.dynamic.queryString.match(string);

        //console.log('OdataStrig', ArradataStrig);
        let OdataStrig = ArradataStrig[0];
        let dataString = ''

        let arrQuerySTemp = ArradataStrig[1].split('$');
        let query = arrQuerySTemp[0];
        let filter = ''
        console.log(this.dataJson);
        if (typeof this.dataSet[arrQuerySTemp[1]] != 'undefined') {
          if (this.dataSet[arrQuerySTemp[1]]) {
            filter = this.dataSet[arrQuerySTemp[1]];

            filter = data.dynamic.queryString.replace(ArradataStrig[1], filter)
          }

        } else if (this.dataJson[arrQuerySTemp[1]]) {
          filter = this.dataJson[arrQuerySTemp[1]];
          filter = data.dynamic.queryString.replace(ArradataStrig[1], filter)
        }
        dataString = query + filter

        if (typeof filter != 'undefined') {
          queryString = query + filter + filerStatic;
        }
        //console.log('dataString', queryString)
      } else if (data.dynamic.queryString.includes('$')) {

        let arrQuerySTemp = data.dynamic.queryString.split('$');

        let query = arrQuerySTemp[0];
        let filter = ''
        if (typeof this.dataSet[arrQuerySTemp[1]] != 'undefined') {
          filter = this.dataSet[arrQuerySTemp[1]];

          this.formData.filter(res => res.dataField == arrQuerySTemp[1])
          if (filter == null || filter == '') {
            let ffff = this.dataFields[arrQuerySTemp[1]]



            alert('Selezionare prima: ' + ((ffff.caption) ? ffff.caption : arrQuerySTemp[1]), 'Attenzione!');
            return

          }
        }
        if (typeof filter != 'undefined') {
          queryString = query + filter + filerStatic;
        }

      } else {
        queryString = data.dynamic.queryString + filerStatic;
      }
      this.componentData['dynamic']['queryStringFilter'] = queryString
    } else {
      this.componentData['dynamic']['queryStringFilter'] = filerStatic
    }

    ////console.log('queryString', this.componentData['dynamic']['queryStringFilter'])

    if (this.componentData['dynamic']['costantValue']) {

      const costantValue = this.componentData['dynamic']['costantValue'];
      let values
      costantValue.forEach(element => {
        let keyEle = element['key'];
        let val = ''
        if (typeof this.dataSet[element['value']] != 'undefined') {
          val = this.dataSet[element['value']]
        } else {
          val = element['value']
        }

        values = { ...values, [keyEle]: val }
      })
      this.costantValuesToDynamic = values

    }

    /*if (this.dataSet[data.dynamic.filter]) {


      this.componentData['dynamic']['queryString'] = '/' + this.dataSet[data.dynamic.filter];
      
    }*/




    this.setStyle();
    /*
      se e solo se decido di inviare più campi alla griglia dinamica magari per effettuare dei filtri sui campi da mostrare o altro
      per ora mi limito ad inviare il campo oggetto, vedi esempio in AlboAutmezzo  per selezionare le colonne visto che ho deciso di non utilizzare il tagBox come campo

    */

    if (typeof this.componentData['dynamic']['settingGrid'] != 'undefined') {
      if (typeof this.componentData['dynamic']['settingGrid']['dataInput'] != 'undefined') {
        const dataInput = this.componentData['dynamic']['settingGrid']['dataInput'];

        this.dataSedDynamicContent = this.dataSet[dataInput]

      } else {
        this.dataSedDynamicContent = this.dataSet[this.componentData['dataField']]
      }
    }


    //this.dataSedDynamicContent = this.dataSet[this.componentData['dataField']]


    if (this.componentData['dynamic']['buttonOption']['event'] == 'inLine') {
      setTimeout(() => {
        let element = document.querySelectorAll('[name=' + this.componentData['dataField'] + ']');
        this.elementTarget = '#' + element[0].getAttribute('id');
        if (typeof this.componentData['dynamic']['settingGrid'] != 'undefined') {
          this.height = this.componentData['dynamic']['settingGrid']['height'];
          this.heightWrap = this.height + 80;
        }
        this.showDynamicPopOver = !this.showDynamicPopOver;

      }, 500);



    } else {

      setTimeout(() => {

        this.showDynamicContent = !this.showDynamicContent;
        if (typeof this.componentData['dynamic']['settingGrid'] != 'undefined') {
          this.height = this.componentData['dynamic']['settingGrid']['height'];
          this.heightWrap = this.height + 80;
        }

      }, 500);

    }




  }

  setStyle() {


    if (!this.showDynamicContent) {


      this.width = '805'
      this.height = '570'

      this.heightWrap = 610;

    }

  }

  //Griglia multiselect


  emittendSelectionMultipleRow(e: any) {

    let key = e.component.dataField;
    let newItem
    this.dataSet[key] = null
    if (e.data.length > 0) {
      newItem = { ...this.dataSet, [key]: e.data }

      this.dataSet = newItem;

    } else {
      newItem = { ...this.dataSet, [key]: null }
      this.dataSet = newItem

    }

    /***Se ci sono campi relazionari***/
    if (typeof e.related != 'undefined') {

      let related = e.related
      if (typeof related != 'undefined') {
        if (related.length > 0 || Object.keys(related).length > 0) {

          e.component.dynamic.related.forEach((value, key) => {

            this.dataSet[value] = related[value]

          })
        }


      }
    }


    if (e.name == 'saveMultipleSelectionsRowGrid') {
      this.hidePopUp();


      /* if (typeof this.toolbarBottomForm == 'undefined') {
        return
      }


      const buttons = this.toolbarBottomForm.items.map(buttons => {
        buttons.options.disabled = false;
        return buttons
      })

      this.toolbarBottomForm.instance.option('items', buttons) */

    }
  }

  //Griglia selezione singola

  updateFiedlFromGridSelection(data, item, component?) {

    if (data) {

      let valueExpr = item.dynamic.valueExpr != '' ? item.dynamic.valueExpr : item.dynamic.displayExpr
      let displayExpr = item.dynamic.displayExpr
      let value
      if (Array.isArray(displayExpr)) {
        let val = []
        displayExpr.forEach(res => {
          if (data[res]) {
            let value1 = this.dateParse(data[res])
            val.push(value1)
          }

        })
        value = val.join(' - ');
      } else {
        if (data[valueExpr]) {
          let value2 = this.dateParse(data[valueExpr])
          value = value2;
        }

      }

      if (!value) {
        return
      }

      let descrizione = '';




      let key = item.dataField;

      /***Se ci sono campi relazionari***/

      let related = item.dynamic.related

      /***************************************/
      const keyVariable = key;
      const valueArray = value;



      const newItem = { ...this.dataSet, [keyVariable]: valueArray };

      this.dataSet = newItem


      if (related) {

        let newItem;
        let newItemDesc;
        related.forEach((values, key) => {
          let arrayValue = values.split('|')
          if (arrayValue.length > 1) {
            newItem = { ...this.dataSet, [arrayValue[1]]: data[arrayValue[0]] };
            newItemDesc = { ...this.dataSetDesc, [arrayValue[1]]: data[arrayValue[0]] };

          } else {
            newItem = { ...this.dataSet, [values]: data[values] };
            newItemDesc = { ...this.dataSetDesc, [values]: data[values] };
          }

          this.dataSetDesc = newItemDesc

          this.dataSet = newItem

        })

      }

      if (component) {


        this.userComponentService.destroyCurrentOpenPopUp(component);
        this.userComponentService.destroyOutputComponent();

        this.userComponentService.removeNavigationComponent(item.dynamic.service, component)

      }

    }
  }

  updateFiedlFromGridMultipleSelection(data, item, component?) {

    if (data) {

      if (Array.isArray(data)) {
        let dataSel = data.map(res => {
          if (item.dynamic.valueExpr == item.dynamic.displayExpr) {
            let value1 = this.dateParse(res[item.dynamic.valueExpr])
            return value1
          } else {

            let displayExpr = item.dynamic.valueExpr != '' ? item.dynamic.valueExpr : item.dynamic.displayExpr
            if (displayExpr == 'object') {
              return res
            } else {
              let value2 = this.dateParse(res[displayExpr])
              return value2
            }

            //return res[item.dynamic.displayExpr]
          }

        })
        this.dataSet[item.dataField] = dataSel;


      }


      let related = item.dynamic.related




      if (related) {

        let newItem;
        let newItemDesc;
        related.forEach((values, key) => {
          let arrayValue = values.split('|')
          if (arrayValue.length > 1) {

            this.dataSet[arrayValue[1]] = data[arrayValue[0]]
          } else {
            if (typeof data[values] != 'undefined') {
              this.dataSet[values] = data[values]
            } else {
              this.dataSet[values] = data
            }

          }


        })

      }

      if (component) {


        this.userComponentService.destroyCurrentOpenPopUp(component);
        this.userComponentService.destroyOutputComponent();

        this.userComponentService.removeNavigationComponent(item.dynamic.service, component)

      }








    }
  }

  emittendSelectionRow(e: any) {


    if (e.data && e.component) {

      let valueExpr = e.component.dynamic.valueExpr != '' ? e.component.dynamic.valueExpr : e.component.dynamic.displayExpr
      let displayExpr = e.component.dynamic.displayExpr
      let value
      if (Array.isArray(displayExpr)) {
        value = e.data['displayExpr'].join(' - ');
      } else {
        value = e.data[valueExpr];
      }



      let descrizione = '';

      if (e.component.dynamic.valueExpr != '') {
        descrizione = e.data[displayExpr]
      }


      let key = e.component.dataField;

      /***Se ci sono campi relazionari***/

      let related = e.component.dynamic.related
      /***************************************/
      const keyVariable = key;
      const valueArray = value;



      const newItem = { ...this.dataSet, [keyVariable]: valueArray };

      this.dataSet = newItem



      if (e.component.costantValue) {
        e.component.costantValue.forEach(values => {
          this.dataSet[values.key] = values.value;
        })
      }
      if (e.data.related) {

        let rel = e.data.related
        let newItem;
        let newItemDesc;
        related.forEach((values, key) => {
          let arrayValue = values.split('|')
          if (arrayValue.length > 1) {
            newItem = { ...this.dataSet, [arrayValue[1]]: rel[arrayValue[1]] };
            newItemDesc = { ...this.dataSetDesc, [arrayValue[1]]: rel[arrayValue[1]] };

          } else {
            newItem = { ...this.dataSet, [values]: rel[values] };
            newItemDesc = { ...this.dataSetDesc, [values]: rel[values] };
          }

          this.dataSetDesc = newItemDesc

          this.dataSet = newItem

        })

      }



      let close = false;
      if (e.isNotClose) {
        close = e.isNotClose
      } else {
        this.apiSource = '';
        this.componentType = "";
        this.componentData = '';
      }
      this.showDynamicContent = close;

    } else {
      if (e)
        this.dataSet = e

    }

    let dataTosend = {
      name: 'selectedDinamicGrid',
      dataForm: this.dataSet,
      selectRow: e.data.selectRow,
      parentComponent: e.component,
      masterComponent: this.formEdit.instance
    }
    this.emittendButtonPush.emit(dataTosend)
    //this.formEdit.instance.option(g,e.data.descrizione)
  }


  onClickOutsideSearchBox(event) {

    let targetClass = event.target.className;
    let includes = targetClass.indexOf('abolute-list') !== -1

    if (!includes) {

      this.searchDataShow = false;

    }
  }

  /****Eventi Toolbar****/


  toolbarEvent(e) {

    if (e == 'close') {

      this.apiSource = '';
      this.componentType = "";
      this.componentData = '';
      this.showDynamicContent = false;

      this.emittendSelectionRow('')
    }


  }

  showingPopUp(e) {

    e.component.content().parentNode.classList.add("formEditPopup"); //add class to overlay content
    e.component.content().classList.add("formEditPopupContet"); //add class to content
    e.component.content().classList.add("bg-grey"); //add class to content


  }

  hidePopUp(e?) {

    //////////console.log(e)
    this.apiSource = '';
    this.componentType = "";
    this.componentData = '';
    this.costantValuesToDynamic = ""
    this.showDynamicContent = false;
    this.height = '';
    this.heightWrap = '';

    this.showDynamicPopOver = false

    ///Hai commentato per cercare di capire come fare per mettere la descrizione e salvare l'ID
    //this.emittendSelectionRow('')


  }

  emittedGridInit(e) {

    ////console.log(e.name,e);
    if (e.name == 'onContentReadyFirstLoad') {
      this.formRefreshInputData(e.campo, e.dataSource)
      e.name = 'grigliaCambiata';
      e.component = this.formEdit.instance
      this.emittendButtonPush.emit(e)


    }
    if (e.name == 'onInitialized') {

      console.log('onInitialized-->', e);

      e.name = 'grigliaOnInitialized';
      //e.masterComponent = this.formEdit.instance;

      this.emittendButtonPush.emit(e)


    }

    if (e.name == 'onCellPrepared') {
      // //console.log('onCellPrepared',e)

      this.emittendButtonPush.emit(e);
    }
  }
  emittedGridEvent(e) {


    //console.log('emittedGridEvent',e);



    if (e.name == 'buttonNewRowEvent') {
      //e.cancel = true
      this.emittendButtonPush.emit(e);

      return
    }
    if (e.name == 'onInitNewRow' || e.name == 'onEditorPrepared') {
      //e.cancel = true
      this.emittendButtonPush.emit(e);
      return
    }

    if (e.name == 'toolBarPreparing') {
      ////console.log('toolBarPrepared', e)

      this.emittendButtonPush.emit(e);
      return

    }
    if (e.name == 'gridToolBarButtonClick') {
      //console.log('gridToolBarButtonClick', e)

      this.emittendButtonPush.emit(e);
      return

    }
    if (e.name == 'colonnaButtonClick') {
      //console.log('colonnaButtonClick', e)

      this.emittendButtonPush.emit(e);
      return

    }
    if (e.name == 'onRowValidating') {
      this.emittendButtonPush.emit(e);
      return
    }

    if (e.name == 'onEditingStart') {
      const buttons = this.toolbarBottomForm.items.map(buttons => {
        buttons.options.disabled = true;
        return buttons
      })
      //this.toolbarBottomForm.instance.option('items', buttons);
      ////console.log('onEditingStart', e)
      //e.masterComponent.selectRowsByIndexes(e.key)
      e.name = 'onEditingStart'
      this.emittendButtonPush.emit(e);
      return
    }

    if (e.name == 'onMasterDetailEdit') {
      //console.log('onMasterDetailEdit', e)
      //e.masterComponent.selectRowsByIndexes(e.key)
      this.emittendButtonPush.emit(e);
    }

    if (e.name == 'onEditCanceling') {
      const buttons = this.toolbarBottomForm.items.map(buttons => {
        buttons.options.disabled = false;
        return buttons
      })
      this.toolbarBottomForm.instance.option('items', buttons);
      //console.log('onEditCanceled', e)
      //e.masterComponent.selectRowsByIndexes(e.key)
      this.emittendButtonPush.emit(e);
      return
    }
    if (e.name == 'onRowUpdated') {
      this.emittendButtonPush.emit(e);
      return
    }

    if (e.name == 'onContentReady') {
      let component = e.component;





      // //console.log('onContentReady', e)
      /* if (!e.masterComponent.getSelectedRowKeys().length) {
        e.masterComponent.selectRowsByIndexes(0);
      } */

      let key = component.dataField;
      let newItem
      this.dataSet[key] = null
      if (e.data.length > 0) {
        newItem = { ...this.dataSet, [key]: e.data }

        this.dataSet = newItem;
        this.dataSetCopy = newItem

      } else {
        newItem = { ...this.dataSet, [key]: null }
        this.dataSet = newItem

        this.dataSetCopy = newItem
      }


      return
    }

    if (e.name == 'onEditCanceled') {

      if (typeof e.masterComponent != 'undefined') {
        const hasEditData = e.masterComponent.hasEditData()
        if (typeof this.toolbarBottomForm == 'undefined') {
          return
        }


        const buttons = this.toolbarBottomForm.items.map(buttons => {
          buttons.options.disabled = false;
          return buttons
        })

        //this.toolbarBottomForm.instance.option('items', buttons)

      }

    }

    let component = e.component;
    if (e.name == 'beforeSavingDynamiGrid') {
      this.emittendButtonPush.emit(e);

    }
    if (e.name == 'onSavingDynamiGrid') {
      //console.log('onSavingDynamiGrid', e)
      //this.emittendButtonPush.emit(e)
      let key = component.dataField;
      let newItem
      this.dataSet[key] = null
      if (e.data.length > 0) {
        newItem = { ...this.dataSet, [key]: e.data }
        this.dataSet = newItem;
      } else {
        newItem = { ...this.dataSet, [key]: null }
        this.dataSet = newItem
      }

      /***Se ci sono campi relazionari***/
      let related = e.related
      if (related) {
        e.component.dynamic.related.forEach((value, key) => {

          this.dataSet[value] = related[value]

        })


      }

      if (e.name == 'saveSelectionedsRowGrid') {
        this.hidePopUp();
        const hasEditData = e.masterComponent.hasEditData()
        if (typeof this.toolbarBottomForm == 'undefined') {
          return
        }


        const buttons = this.toolbarBottomForm.items.map(buttons => {
          buttons.options.disabled = false;
          return buttons
        })

        //this.toolbarBottomForm.instance.option('items', buttons)

      }

      if (typeof e.masterComponent != 'undefined' && e.name != 'selectionItemList') {

        if (typeof this.toolbarBottomForm == 'undefined') {
          return
        }


        const buttons = this.toolbarBottomForm.items.map(buttons => {
          buttons.options.disabled = false;
          return buttons
        })

        //this.toolbarBottomForm.instance.option('items', buttons)

      }
      let dataEm = {
        event: 'onSavingDynamiGrid',
        data: this.dataSet[key],
        component: this.dynamicComponentItem
      }
      this.emittendButtonPush.emit(dataEm);


    }


    if (e.name == 'onRowExpanded') {
      this.emittendButtonPush.emit(e);
    }

    if (e.name == 'close') {
      this.hidePopUp();
    }
    if (e.name == 'customButtonGriglia') {
      this.emittendButtonPush.emit(e);
    }
    if (e.name == 'selectionRowGridList') {
      e.component = this.formEdit.instance
      this.emittendButtonPush.emit(e);
    }

  }
  emittedToolbarEventFromDynamic(e) {

    if (e == 'close')
      this.showDynamicPopOver = false;
  }

  /****Fine Eventi ToolBar****/

  validationCallback(e) {
    ////console.log(e)
  }

  startComponent(ev) {
    ////console.log(ev.itemIndex)
    if (typeof ev.itemIndex != 'undefined') {

      this.formTabselectedIndex = ev.itemIndex;

    }
    //alert(this.formTabselectedIndex+'','itemIndex')
  }

  public validationElement(campo) {
    let valInstance;
    const validationRules = [{
      type: 'required',
      message: 'obbligatorio'
    }]
    let valElement = this.formEdit.instance.getEditor(campo).element();




    ////console.log(valElement)


    if (typeof valElement != 'undefined')
      valInstance = Validator.getInstance(campo) as Validator;
    if (typeof valInstance != 'undefined')


      // valInstance.option("validationGroup", validationDataName);
      valInstance.option("validationRules", validationRules);

  }

  //Parsing della data con l'orario
  public dateParse(dateTime) {
    let dateString = ''
    let dateType = /(\d{4})([\/-])(\d{1,2})\2(\d{1,2})/;
    let isMatch = dateType.test(dateTime);

    if (isMatch) {
      let date = new Date(dateTime)
      let month = ("0" + (date.getMonth() + 1)).slice(-2); month + 1
      let day = date.getDate().toString().padStart(2, '0');

      dateString = day + '/' + month + '/' + date.getFullYear();

    } else {
      dateString = dateTime
    }

    return dateString
  }

  //parsing del numero

  public parseFormatNumber(e) {

    const campo = e.component.option('inputAttr').campo;

    console.log('parseFormatNumber', e)

    const event = e.event;
    // check if 'dot' is entered
    if (event.key === ".") {
      event.preventDefault();
      event.stopPropagation();

      var input = e.element.querySelector("input.dx-texteditor-input");
      if (!input.value.includes(','))
        e.component._setInputText(input.value + ",");

      //e.component.updateData(campo.dataField, value) 
      input.setSelectionRange(input.value.length, input.value.length);
    }


  }

  getDynamicImage(campo) {

    this.imageSources[campo.dataField] = campo.src;

    this.emittendButtonPush.emit(campo.dataField);
  }


  comparisonFunction = () => {
    //console.log('compareValue', this.compareValue)
    return this.dataSet[this.compareValue];

  }

  async resettaGriglie() {

    console.warn(this.griglie);

    if (!this.griglie)
      return;



    this.griglie.forEach(
      async (griglia: GrigliaComponent) => {

        griglia.selectedRowKeys = [];
        await griglia.gridSelection.instance.refresh();
      }
    );
  }

  onSelezioneGriglia(evt, dataField) {

    console.warn(dataField, evt);

    if (dataField) {

      if ((evt as any[]).length == 0) {


        this.formRefreshInputData(dataField, undefined);
        delete this.formEdit.formData[dataField];

      }
      else
        this.formRefreshInputData(dataField, evt);


    }

  }

  updateGriglia(dataField: string, dati: any[]) {



    this.griglie.forEach(
      (griglia) => {

        if (griglia.name == dataField) {


          griglia.selectedRowKeys = dati;

        }

      }
    );

  }




  tabContentReady(e) {
    //console.log('tabContentReady', e.component.element.classList)

    $('.dx-tabs').addClass("nica-nav-tabs")

    // e.component.content().parentNode.classList.add("formEditPopup"); //add class to overlay content
    //e.component.element.classList.add("nica-nav-tabs"); //add class to content
    //e.component.content().classList.add("bg-grey"); //add class to content

  }


  hideFormTab(groupDataField: string) {

    if (!groupDataField || !this.formTabs)
      return;


    console.warn(this.formTabs)

  }



  onRadioGroupValueChanged(evt: any, dataField: string) {



    if (!evt.value && !dataField)
      return;



    this.formRefreshInputData(dataField, evt.value);

    //console.warn(this.gruppiRadio);

    /*
    let radioGroup = this.radioGroups.find(
      (radioGroup)=>radioGroup.name == dataField
    );

    if(!radioGroup)
      return;

    radioGroup.value = evt.value;  

    if (this.radioGroups.find.name == dataField)
      radioGroup.value = evt.value;
    */

    console.warn(evt, dataField);

    let radioGroup = this.radioGroups.find(
      (radioGroup) => radioGroup.name == dataField
    );

    if (radioGroup)
      radioGroup.instance.option('value', evt.value);


  }

  disableRadioGroup(dataField: string) {




    let radioGroup = this.radioGroups.find(
      (radioGroup) => radioGroup.name == dataField
    );

    if (!radioGroup)
      return;

    radioGroup.disabled = true;
    /*
    let radioGroupFound = this.gruppiRadio.find(
      (radioGroup)=>{
        return radioGroup.name == dataField
      }
    );

    if(radioGroupFound){

      radioGroupFound.value = evt.value;


    }
    */

  }
  notifica(message, positionH = 'center', positionW = 'center', type = 'success') {
    notify({
      message: message,
      height: 45,
      width: 250,
      position: positionH + ' ' + positionW

    }, type, 3000);
  }
  fullscreen(ev) {
    this.fullScreen = !this.fullScreen;

    this.width = '100%'
  }
  /***eventi per comonente no devExtreme */
  keyDown(w: any) {
    // premuto tasto accept_characters
    //alert("wwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwwww","wwww");
    if (w.event.keyCode == 112) { // F1
      w.event.key = null
      w.event.stopPropagation();
      w.event.preventDefault();
      return true;
    }

    if (w.event.keyCode > 112 && w.event.keyCode < 124) return false; // tasti funzionali
    if (w.event.keyCode >= 16 && w.event.keyCode < 20) return false; // tasti funzionali

    let keyCodeEsculi = [8, 46, 37, 39, 38, 40, 9]
    if (keyCodeEsculi.includes(w.event.keyCode)) return false;

    //Prog=w.event.target.attributes[2] 
    let rr1 = Object.entries(w.event.target.attributes)
    let trovato = false;
    for (let t = 0; t < rr1.length; t++) {
      if (rr1[t][1]["name"] == 'acceptonlycharacters' && rr1[t][1]['value'] > '') {
        trovato = true;
        if (rr1[t][1]['value'][0] == "/") {
          let result = rr1[t][1]['value'].substring(1, rr1[t][1]['value'].length - 1);
          var test = new RegExp(result, 'm');
          var st = "" + w.event.key;
          let m;
          if ((m = test.exec(st)) !== null) {
            /* m.forEach((match, groupIndex) => {
               console.log(`Found match, group ${groupIndex}: ${match}`);
           });*/
          }
          if (!st.match(test)) {
            w.event.key = null
            w.event.preventDefault();
            return true;
          }
          continue;
        } else {
          let KeyAccept = "" + rr1[t][1]['value'];
          if (!KeyAccept.includes(w.event.key)) {
            w.event.key = null
            w.event.preventDefault();
            return true;
          }
        }
      }
      //keyDown
    }
    if (!trovato) {
      if (w.component.NAME == 'dxTextBox') {
        let result = environment.GENERIC_STRING;
        result = result.substring(1, result.length - 1)
        var test = new RegExp(result, 'm');
        var st = "" + w.event.key;
        if (!st.match(test)) {
          w.event.key = null
          w.event.preventDefault();
          return true;
        }
      }
    }
    return false;


    let rr = Object.values(w.event.target.attributes).find(element => element['name'] == 'accept_characters');
    if (rr) {
      //rr.includes(w.key)    
      let gg = (JSON.stringify(rr, ["name"]));
      //console.log((rr['accept_characters']));
    }
  }

  emitButtonDynamic(event) {
    //console.log('emitButtonD88888ynamic', event)

    switch (event.name) {
      case 'emitButtonDynamic':
        const campo = event;

        const componentType = campo.dynamic.componentType
        this.enableEditDynamicGrid = campo.dynamic.enableEditor ? true : false
        this.eventmitter(campo, event, componentType, campo.dynamic.dataSource, campo.dynamic.caption)
        break;
      case 'emitButtonType2':
        this.actionCampoButton(event);
        break;

      default:
        break;
    }

  }

  actionCampoButton(campo) {
    let dataEditForm = this.dataSet;

    if (typeof campo.button.outPutValue != 'undefined' && campo.button.outPutValue == true) {


      if (typeof dataEditForm[campo.dataField] == 'undefined' || dataEditForm[campo.dataField].length == 0 || dataEditForm[campo.dataField] == '') {
        alert('Nessun valore, il campo è vuoto ', 'Attenzione!')
        return
      }
      let dataToSend = {
        name: campo.button.name,

        campo: campo,
        campoButton: campo.button,
        event: campo.event,
        data: dataEditForm,
        masterComponent: this.formEdit.instance
      }

      this.emittendButtonPush.emit(dataToSend);

    } else {

      let dataToSend = {
        name: campo.button.name,
        campo: campo,
        campoButton: campo.button,
        event: campo.button.event,
        data: dataEditForm,
        masterComponent: this.formEdit.instance
      }
      this.emittendButtonPush.emit(dataToSend)
    }


  }
  outputElementValue(ev) {
    if (ev.name = 'onFocusOut') {
      this.getElementValue(ev.valueCampo, ev.campo, 'onFocusOut')
    }

  }



  async generaOdata(filtered?: string) {
    /*
    contains(Name, 'phone')
    substringof('ignazio',tolower(descrizioneScheda))
    contains(tolower(descrizione),'pippo')
examplefilter:'
        [
          ["descrizioneScheda", "contains", "{{descrizioneScheda}}"],
          "and",
          [
              ["idTipoRaee", "=", "{{idTipoRaee}}"],
            "or",
            ["idTipoRaee", "=", "{{idTipoRaee}}""]
          ]
          "and"
          ["quantitaPrevista", ">", {{quantitaPrevista}}],
        ]
    '


    */
    let formData = []
    let i = -1, idx = 0
    let filterOdataWrapper = []
    let filterOdata
    formData = this.formData.filter(r => r.itemType == 'group');
    let newData: any[] = [];
    filterOdataWrapper[0] = []
    i = 0;
    let fieldTypes = [];

    if (typeof filtered === "string" && filtered !== null && filtered.length > 0) {
      // filtro in string
      //console.log(this.dataFields['descrizioneScheda'])
      var variable = filtered.match(/{{[\w\d]+}}/g);
      for (let r = 0; r < variable.length; r++) {
        let v = variable[r].replace('}}', '');
        v = v.replace('{{', '');
        //aggiungere il controllo su newData
        filtered = filtered.replace(variable[r], this.formEdit.formData[v])
        let cField = {
          [this.dataFields[v]]: this.dataFields[v].odataType,
        }
        fieldTypes.push(cField)
      }
      //--------------------------       
      filterOdataWrapper = eval(filtered);

    } else {
      formData.forEach(gruppo => {
        //let logicalOperator = gruppo.logicalOperator
        //filterOdataWrapper.push(logicalOperator)  
        //i=filterOdataWrapper.length;
        //filterOdataWrapper[i]=[]
        //i++;
        //filterOdataWrapper[i]=[]
        gruppo.data.forEach(dataR => {
          //idx++;      
          /*
 odataType:'string',
        odataFilter:'=',
        fields: Array<any>
          */
          if (dataR.odataFilter > "") {
            filterOdataWrapper[i][idx] = []
            filterOdataWrapper[i][idx][0] = [] //prima lo zeronon c'era
            filterOdataWrapper[i][idx][0].push(dataR.dataField)
            filterOdataWrapper[i][idx][0].push(dataR.odataFilter)
            if (dataR.odataType == 'date')
              filterOdataWrapper[i][idx][0].push("!" + this.formEdit.formData[dataR.dataField] + '!')
            else
              filterOdataWrapper[i][idx][0].push(this.formEdit.formData[dataR.dataField])
            if (dataR.odataRelated && dataR.odataRelated.length > 0) {
              let rt = 1;
              for (let ii = 0; ii < dataR.odataRelated.length; ii++) {
                filterOdataWrapper[i][idx][rt] = "or";//.push("or")

                filterOdataWrapper[i][idx][rt + 1] = []
                filterOdataWrapper[i][idx][rt + 1].push(dataR.odataRelated[ii])
                filterOdataWrapper[i][idx][rt + 1].push(dataR.odataFilter)
                filterOdataWrapper[i][idx][rt + 1].push(this.formEdit.formData[dataR.dataField])
                rt += 2;
              }
            }

            let cField = {
              [dataR.dataField]: dataR.odataType,
            }
            fieldTypes.push(cField)

            i++;
            filterOdataWrapper[i] = 'and';
            i++;
            filterOdataWrapper[i] = []
          }
        })
      })
      filterOdataWrapper.splice(-2)
    }
    //-----------------------------


    let dataSource = new DataSource({
      store: new ODataStore({
        fieldTypes: fieldTypes,
        version: 4,
        url: "https://js.devexpress.com/Demos/DevAV/odata/Products",
      }),

      /*select: [
          'Product_ID',
          'Product_Name',
          'Product_Cost',
          'Product_Sale_Price',
          'Product_Retail_Price',
          'Product_Current_Inventory'
      ]*/
    });

    const store = new ODataStore({
      fieldTypes: fieldTypes,
      version: 3,
      url: "",
      beforeSend: function (e) {
        let regex = /'!/gi;
        filterOdata = e.params.$filter.replaceAll(regex, '');
        regex = /!'/gi;
        filterOdata = filterOdata.replaceAll(regex, '');
        regex = /T00:00:00/gi;
        filterOdata = filterOdata.replaceAll(regex, '');


        //cicciobello=e.params.$filter.replaceAll("'!", '');
        //cicciobello=cicciobello.replaceAll("!'", '').then(result=>{
        //cicciobello=e.params.$filter.replaceAll("'!", '');

        //cicciobello=e.params.$filter
        // return e.params.$filter;
        //throw "Error 42";
        //return e.params.$filter;
      }
    });

    let pippo = await store.load({ filter: filterOdataWrapper });



    filterOdata = filterOdata.replaceAll('substringof', 'contains')
    /*let variables = cicciobello.match(/substringof\(([^)]+)\)/g);
    for(let ii=0;ii<variables.length;ii++){
      let result=variables[ii].replace('substringof','contains');
      cicciobello=cicciobello.replace(variables[ii],result) 
    }           
    console.log(variables)*/
    return filterOdata


    //------------------------------
    // return filterOdataWrapper
  }

}


/**
 * 
 * http://rentrincloud.it:8080/api/SoggettoSede/GetAllSoggettiAndSedi?$expand=sede($filter=(contains(tolower(Descrizione), 'nica'))) - CORRETTA (vedo array vuoti ma posso usare contains)



    http://rentrincloud.it:8080/api/SoggettoSede/GetAllSoggettiAndSedi?$expand=sede&$filter=sede/any(r:r/id eq 14) - CORRETTA (non vedo array vuoti ma non posso usare contains)
 * 
 */